<template>
    <div class="hello">
        <div class="navtitle_box dia" :style="{paddingTop:statusBarHeight*1.3+'px'}">
            <div class="dis arrow_left" @click="getBack" :style="{top:statusBarHeight+'px'}">
                <img src="../../static/img/arrow_left.png" alt="" />
            </div>
            <div class="navtitle_name" :style="{top:statusBarHeight+'px'}">{{scenicName}}</div>
        </div>
        <div id="allmap" class="maps" ref="allmap">
            <!-- <bm-circle :center="circlePath.center" :radius="circlePath.radius" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2"  :editing="true"></bm-circle> -->
        </div>
        <div id class="border-box" ref="borderBox"></div>
        <div id class="voice-lists-play-box" ref="voiceListsPlay"></div>

        <transition name="fade">
            <loading v-if="isloading" :msg="loadingTxt" :loadingVoice="loadingVoice" @func="closedFn"></loading>
        </transition>
        <!--滚动-->
        <div id class="roll-slider" v-if="noticeContent != ''">
            <marquee class="roll-model" behavior="scroll" scrolldelay="200" scrollamount="5">{{ noticeContent }}
            </marquee>
            <i class="roll-icon"></i>
        </div>
        <div class="nav-btns" v-if="scenicName != '' && houtai == ''"
            :class="isAnimateLeft ? 'animateLeft' : 'animateRight'">
            <div class="btn btns_list" @click.prevent="onClickCollect" :class="{ active: isMuseumActive }">
                <img v-if="isollect === 2" class="btns_list-icon" src="../../static/img/collect.png" alt="" />
                <img v-else class="btns_list-icon" src="../../static/img/collect.png" alt="" />
                <span>收藏</span>
            </div>
            <div class="btn btns_list" @click.prevent="explainshow" :class="{ active: isMuseumActive }"
                v-if="scenicsBySUUid.guideScenics.recorders!='undefind' &&scenicsBySUUid.guideScenics.recorders!=null">
                <img class="btns_list-icon" src="../../static/img/explain.png" alt="" />
                <span>讲解</span>
            </div>
            <div class="btn shift-e-c" :class="{ active: isChEnActive }" v-if="isEn == 1" @click.prevent="ChEnSwitchFn">
            </div>
            <div class="btn shihuacao" v-if="isRecognized == 1" @click.prevent="shibieflowersFn"></div>
            <div class="btn scenic" @click.prevent="scenicActiveTabEnd(0)"
                :class="{ active: ismodelActive && currentIconIndex == 0 }"></div>
            <div class="btn line" @click.prevent="recommendedLineTabEnd(3)"
                :class="{ active: ismodelActive && currentIconIndex == 3 }"></div>
            <div class="btn jubu" v-if="subDetails != null" :class="{ active: subDetailsModelFlag == 2 }"
                @click="subDetailsModelFn"></div>
            <div class="btn btns_list" @click.prevent="onClicpopup" :class="{ active: isMuseumActive }">
                <img class="btns_list-icon" src="../../static/img/home-list.svg" alt="" />
                <span>列表</span>
            </div>
        </div>
        <div class="sub-details-model" :class="{
        animateOut: subDetailsModelFlag == 1,
        animateIn: subDetailsModelFlag == 2,
      }">
            <div class="sub-details-list" :class="{ active: index == subDetailsListIndex }" :key="index"
                v-for="(item, index) in subDetails != null ? subDetails.list : []" @click="subDetailsListFn(index)">
                <div class="name">{{ item.scenic }}</div>
                <div class="icon"></div>
            </div>
        </div>
        <div class="zoom-tap zoom-left zoom-tap_a" id="tapZoom" v-if="minZoomlevel != maxZoomlevel && houtai == ''"
            :class="isAnimateLeft ? 'animate-left' : 'animateRight'">
            <div class="self-motion" @click="sliderMoveFn" v-if="scenicName != '' && houtai == ''">
                <div class="radio" :class="isSliderActive ? 'active' : ''"></div>
            </div>
            <div class="prepare" @click="offLine">
                <img src="https://rgkj-oss.oss-cn-heyuan.aliyuncs.com/tumao/smallImg/lxb.png" alt="" />
            </div>
            <div class="btn museum self-motion" @click.prevent="museumFn" v-if="guideMuseum != null"
                :class="{ active: isMuseumActive }"></div>
        </div>
        <!--点击缩放地图  -->
        <div class="zoom-tap" id="tapZoom" v-if="minZoomlevel != maxZoomlevel && houtai == ''"
            :class="isAnimateLeft ? 'animateLeft' : 'animateRight'">
            <!-- <div class="self-motion zoom-itmes" @click="sliderMoveFn" v-if="scenicName!=''&&houtai==''"
				:class="isAnimateLeft?'animateLeft':'animateRight'">
				<div class="radio" :class="isSliderActive?'active':''"></div>
			</div> -->
            <div class="max-zoom" :class="{ active: isMaxActive }" id="maxZoom"
                @touchstart.prevent="handleMaxTouchStart" @touchend.prevent="handleMaxTouchEnd"></div>
            <div class="min-zoom" :class="{ active: isMinActive }" id="minZoom"
                @touchstart.prevent="handleMinTouchStart" @touchend.prevent="handleMinTouchEnd"></div>
        </div>
        <transition name="fade">
            <div class="minOrMaxHint" id="minOrMaxHint" v-if="isMinOrMaxHint">
                <div class="minOrMaxModel">
                    <p id="hintTxt">{{ isMinOrMaxHintTxt }}</p>
                </div>
            </div>
        </transition>
        <!--底部-->
        <div class="footer" v-if="scenicName != '' && isFooterShow">
            <div class="footer-c">
                <div class="f-c footer-ltem" :class="{ active: playOrpause == 2 }" @click="playOrpauseClick">
                    <div class="play_audio">
                        <div class="wrap" id="box">
                            <div class="circle" :style="{ clip: circle }">
                                <div class="left" :style="{ transform: 'rotate(' + rotateNum + 'deg)' }"></div>
                                <div class="right" :style="{ display: isDisplayR }"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="isCurrentPlaying" id="isCurrentPlaying" v-if="isCurrentPlaying == 1">
                <p>{{ currentPlayingTxt }}</p>
            </div>
        </transition>
        <div class="current-img" ref="currentImg" :class="{
        scaleIn: isCurrentPlaying == 1,
        scaleOut: isCurrentPlaying == 2,
      }">
            <img v-bind:src="currentImg" alt />
        </div>
        <transition name="fade">
            <div class="in-or-out" v-if="isInOrOutShow">{{ InOrOutTxt }}</div>
        </transition>
        <transition name="fade">
            <div class="isplay" v-if="isfadeIn" @click="spotCancel()">
                <div id="isplayModel" class="isplayModel" @click.stop="doStoping($event)">
                    <p class="title">提示</p>
                    <p>您已在景区范围内,是否开启自动导览模式?</p>
                    <ul>
                        <li tabindex="0" @click="spotCancel()">取消</li>
                        <li class="active" tabindex="1" @click="spotTrue()">确定</li>
                    </ul>
                </div>
            </div>
        </transition>
        <!-- 离线包下载 -->
        <transition name="fade">
            <van-overlay :show="offLineShow" @click="suspendLine" :z-index="10002" class-name="overlay_line">
                <div class="lineBox">
                    <div class="dis">
                        <img src="https://rgkj-oss.oss-cn-heyuan.aliyuncs.com/tumao/smallImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20241130172946.png"
                            alt="" class="folder" />
                    </div>
                    <div class="dis  package">
                        离线包下载
                    </div>
                    <div class="dis size">
                        离线包共200MB
                    </div>
                    <div class="dis btn"
                        :class="downloadFileIndex==1 || downloadFileIndex==2 || downloadFileIndex==3?'btn_animation':'btn_tran'"
                        @click.stop="downloadFile">
                        <div class="progress-bars dis" :style="{ width: `${downloadprogress}%` }">

                        </div>
                        <div class="" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);"
                            v-if="downloadFileIndex==1">
                            下载
                        </div>
                        <div class="dis"
                            style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);color: #333;width: 100%;"
                            v-else-if="downloadFileIndex==0">
                            下载中 {{downloadprogress}}%
                        </div>
                        <div class="dis"
                            style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);color: #fff;width: 100%;"
                            v-else-if="downloadFileIndex==2">
                            已下载
                        </div>
                        <div class="dis"
                            style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);color: #fff;width: 100%;"
                            v-else-if="downloadFileIndex==3">
                            暂无可用音频下载
                        </div>
                    </div>
                </div>
            </van-overlay>
        </transition>
        <!--点击全部显示全部的语音列表  -->
        <transition name="fade">
            <div class="voice-lists-model" id="voiceListsModel" v-show="isVoiceListsShow" @click="navListsModelTab()">
                <div class="voice-lists-play" ref @click.stop="doStoping($event)">
                    <div class="title">列表</div>
                    <ul id="voiceLists">
                        <div class="clearBox" style="width: 100%; height: 0.8rem"></div>
                        <li class="playOne" data-index="index" v-for="(item, index) in scenicsMarker" :key="index"
                            @click="voiceListsTab(index)" :style="{
                height: item.showType == 'tag' ? '0rem' : '1.1rem',
                'border-bottom':
                  item.showType == 'tag'
                    ? '0rem'
                    : '0.02rem solid rgba(170, 170, 170, 0.2)',
              }">
                            <div class="voice-list-l">
                                <p class="txt" :class="{ animate: isPlayIndex == index }">
                                    {{ item.viewName }}
                                </p>
                                <p class="time" v-if="isPlayIndex == index">{{ timeTxt }}</p>
                                <div class="slider" :class="{ scaleAniamte: isPlayIndex == index }">
                                    <div class="border" ref></div>
                                    <div class="border-yellow" :style="{
                      width: isPlayIndex == index ? minDivLeft : '0px',
                    }"></div>
                                    <div class="move moveDiv" :style="{
                      marginLeft: isPlayIndex == index ? minDivLeft : '0px',
                    }" @touchstart.prevent="moveDivStart" @touchmove.prevent="moveDivMove"
                                        @touchend.prevent="moveDivEnd"></div>
                                </div>
                            </div>
                            <div class="voice-list-r">
                                <i class="playOrpauseTap" data-index="index" :class="{
                    backg1: isPlayIndex == index && !isPlayOrpause,
                    backg2: isPlayIndex == index && isPlayOrpause,
                  }"></i>
                            </div>
                        </li>
                    </ul>
                    <div class="voice-footer" id="voiceFooter" @click="navListsModelTab()">
                        <p></p>
                    </div>
                </div>
            </div>
        </transition>
        <div class="awardtxt" :class="{ active: awardOpactiy }">
            <p>{{ awardTxt }}</p>
        </div>
        <audio src id="music1" hidden ref="music"></audio>
        <div v-wechat-title="this.title"></div>
        <transition name="fade">
            <museum v-if="isMuseum" :guideMuseum="guideMuseum" :guideMuseumNum="guideMuseumNum" @isMuseumFn="func">
            </museum>
        </transition>
        <div class="network" v-if="isNetwork">
            <div class="network-model">
                <div class="network-img"></div>
                <div class="network-txt">加载失败</div>
                <div class="network-btn" @click="reloadFn">点击重新加载</div>
            </div>
        </div>
        <PopUp ref="Popup" :poplist="popUplist" :scenicImgurl="scenicImgurl" :name="title" :uuid="uuid" :userId="userId"
            :legendList="legendList" />
        <!-- 音频播放 -->
        <transition name="fade">
            <van-overlay :show="isexplain" @click.stop="isexplainClose" :z-index="10001" class-name="overlay_video"
                :lock-scroll="false">
                <div class="explainList_box">
                    <div class="dia" style="justify-content: space-between;">
                        <div class="tabs_box">
                            <van-tabs v-model="active" color="#AE5A3D" title-inactive-color="#767676"
                                title-active-color="#AE5A3D" @click.native.stop="tabsBox" v-if="this.Exhibitsindex==0">
                                <van-tab :title="Landmark" name="0"></van-tab>
                                <van-tab :title="scenicSpot" name="1"></van-tab>
                            </van-tabs>
                            <!-- <van-tabs v-model="active" color="#AE5A3D" title-inactive-color="#767676"
								title-active-color="#AE5A3D" @click="tabsBox">
								<van-tab :title="Landmark"></van-tab>
								<van-tab :title="scenicSpot"></van-tab>
							</van-tabs> -->
                        </div>
                        <div class="succession">
                            <div class="dis">
                                <van-switch v-model="continuous" active-color="#AE5A3D" size="20px" class="tabs_size"
                                    @click.stop="" />
                            </div>
                            <div class="succession_play">
                                连续播放
                            </div>
                        </div>
                    </div>
                    <div class="selfWorry" ref="wrapper">
                        <div class="" v-if="storyList.length>0">
                            <div class="" v-for="(item,index) in storyList" :key="index"
                                :class="progressBarIndex+1==index?'selfWorry_box':'selfWorry_boxs'">
                                <div class="dia" style="justify-content: space-between;"
                                    @click.stop="togglePlay(item,index)">
                                    <div class="">
                                        {{index+1}}.{{item.viewName}}
                                    </div>
                                    <div class="dia">
                                        <div class="dis characters" @click.stop="manuscript(item,index)">
                                            <img src="../../static/img/characters.png" alt=""
                                                class="characters_image" />
                                        </div>
                                        <div class="dis characters" @click.stop="playbackSpeed(index)">
                                            <img src="../../static/img/audio_1.0.png" alt="" class="characters_image"
                                                v-if="SpeedIndex==1 && subscript==index" />
                                            <img src="../../static/img/audio_1.0.png" alt="" class="characters_image"
                                                v-if='SpeedIndex==1&&subscript!=index' />
                                            <img src="../../static/img/audio_1.5.png" alt="" class="characters_image"
                                                v-if="SpeedIndex==1.5&& subscript==index" />
                                            <img src="../../static/img/audio_1.0.png" alt="" class="characters_image"
                                                v-if='SpeedIndex==1.5&&subscript!=index' />
                                            <img src="../../static/img/audio_2.0.png" alt="" class="characters_image"
                                                v-if="SpeedIndex==2&& subscript==index" />
                                            <img src="../../static/img/audio_1.0.png" alt="" class="characters_image"
                                                v-if="SpeedIndex==2&& subscript!=index" />
                                        </div>
                                        <div class="dis characters" @click.stop="playbackvolume(index)">
                                            <img src="../../static/img/sound.png" alt="" class="characters_image" />
                                        </div>
                                        <div class="dis" @click.stop="togglePlay(item,index)"
                                            v-if="progressBarIndex!=index">
                                            <img src="../../static/img/play_s.png" alt="" class="characters_image" />
                                        </div>
                                        <div class="dis" v-else @click.stop="togglePlay(item,index)">
                                            <img src="https://rgkj-oss.oss-cn-heyuan.aliyuncs.com/playback.gif" alt=""
                                                class="characters_image" />
                                        </div>

                                    </div>

                                </div>
                                <div class="controls" v-if="progressBarIndex==index">
                                    <div class="progress-bar" @click.stop="seek" ref="progressBar">
                                        <div class="progress" :style="{ width: progressList + '%' }"></div>
                                        <div class="thumb" :style="{ left: progressList + '%' }" @mousedown="startDrag">
                                        </div>
                                    </div>
                                </div>
                                <!-- 音量控制滑块 -->
                                <div class="" v-if="volumecontrol==index">
                                    <div class="slider-container">
                                        <div class="slider-fill" :style="fillStyle"></div>
                                        <input type="range" v-model="sliderValue" :min="min" :max="max"
                                            @input="updateFill" />
                                        <span style="font-size: 12px;">当前音量:{{percentNum}}%
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="" v-else>
                            <van-empty image="https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png"
                                image-size="80" description="暂无音频文件" />
                        </div>
                    </div>
                </div>
            </van-overlay>
        </transition>
        <!-- 音频播放 -->
        <audio ref="audio" id="myAudio" @ended="onAudioEnded" :src="audioSrc" @timeupdate="updateProgressList"></audio>
        <div class="warrp_navtitle" v-if="manuscriptShow">
            <div class="close_box" @click="occlude">
                <img src="/static/img/close.png" alt="" class="close" />
            </div>
            <div class="navtitle dia">
                <div class="navtitle_box dia">
                    <!-- <div class="dis" @click="getBack">
                        <img src="/src/assets/images/arrow_left.png" alt="" />
                    </div> -->
                    <div class="navtitle_name">{{ titleText }}</div>
                </div>
            </div>
            <div class="dis introduction_box">
                <div class="dia">
                    <div class="dis">
                        <img src="/static/img/draft_left.png" alt="" class="draft_left" />
                    </div>
                    <div class="introduction">
                        {{ viewName }}·简介
                    </div>
                    <div class="dis">
                        <img src="/static/img/draft_right.png" alt="" class="draft_right" />
                    </div>
                </div>
            </div>
            <div class="programme">
                <div class="programme_box">
                    <div class="programme_swiper">
                        <span v-if="audioScript!=''">{{audioScript}}</span>
                        <span v-else>暂无文稿</span>
                    </div>
                </div>
            </div>
            <div class="playBack dis">
                <div class="player-progress">
                    <div class="">
                        <div class="controls">
                            <div class="progress-bar" @click.stop="seekdraft" ref="progressBar_box">
                                <div class="progress" :style="{ width: progressList + '%' }"></div>
                                <div class="thumb" :style="{ left: progressList + '%' }" @mousedown="startDrag">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="time-display dia" style="justify-content: space-between;">
                        <div class="">
                            {{ formatTime(currentTime) }}
                        </div>
                        <!-- <div class="">
                            {{ formatTime(duration) }}

                        </div> -->
                    </div>

                    <div class="speed_box">
                        <div class="dia">
                            <!-- <div class="dis">
                                <img src="../../static/img/audio_1.0.png" alt="" class="variable" />
                            </div> -->
                            <div class="dis characters" @click.stop="playbackSpeed(index)">
                                <img src="../../static/img/audio_1.0.png" alt="" class="characters_image"
                                    v-if="SpeedIndex==1 " />

                                <img src="../../static/img/audio_1.5.png" alt="" class="characters_image"
                                    v-if="SpeedIndex==1.5" />

                                <img src="../../static/img/audio_2.0.png" alt="" class="characters_image"
                                    v-if="SpeedIndex==2" />
                            </div>
                            <div class="dis" style="position: absolute;left: 50%;transform: translateX(-46%);">
                                <div class="dis" style="margin-right: 12px;" @click="switchover(0)">
                                    <img src="https://rgkj-oss.oss-cn-heyuan.aliyuncs.com/tumao/smallImg/back.png"
                                        alt="" class="transmit_left" />
                                </div>
                                <div class="dis play_transmit" @click="draftPlay()">
                                    <img src="/static/img/play_bac.png" alt="" class="play_draft" v-if="!isPlaying" />
                                    <img src="/static/img/pause_a.png" alt="" class="play_back" v-else />
                                </div>
                                <div class="dis" @click="switchover(1)" style="margin-left: 12px;">
                                    <img src="/static/img/transmit_right.png" alt="" class="transmit_left" />
                                </div>
                            </div>
                            <!-- <div class="dis" style="margin-left: 24px;">
                                 <img src="/src/assets/images/more.png" alt="" class="more" />
                             </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 讲解员列表 -->
        <transition name="fade">
            <van-overlay :show="show" @click="overlayClose" :z-index="1001" class-name="overlay">
                <div class="explain">
                    <div class="dis commentator" style="color: #333;">
                    </div>
                    <div class="dia" style="flex-wrap: wrap;margin-top: 18px;">
                        <div class="dia explain_increase" style="flex-direction: column;"
                            v-for="(item,index) in scenicsRecorder" :key="index" @click.stop="requestMarkers(index,1)">
                            <div class="dis" :class="index==chooseIndex?'scenicsRecorder_choose':'scenicsRecorder_ch'">
                                <img :src="item.imgurl" alt="" />
                            </div>
                            <div class="explain_name" :class="index==chooseIndex?'scenicsRecorder_name':''">
                                {{item.recoderName}}
                            </div>
                        </div>
                    </div>
                    <div class="dis pack_box" @click="overlayClose">
                        <div class="dia">
                            <div class="pack">
                                点击收起
                            </div>
                            <div class="dis">
                                <img src="/static/img/packup.png" alt="" class="packup" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-overlay>
        </transition>
    </div>
</template>

<script>
    import loading from "@/components/loadingComponent/loading";
    import museum from "@/components/museumComponent/museum";
    import PopUp from "@/components/pop-up";
    import
    WGS84ToGCJ02
    from '@/utils/coordinate'; // 引入坐标转换工具函数
    import {
        calcDistance
    } from "../utils/index";
    import axios from "axios";
    import {
        Toast
    } from 'vant';
    export default {
        name: "pageIndex",
        data() {
            return {
                chooseIndex: 0,
                show: false,
                explainBarHeight: "44",
                circlePath: {
                    center: {
                        lng: 116.396652,
                        lat: 39.92121849,
                    },
                    radius: 500,
                },
                volume: 1, // 默认音量为最大
                min: 0,
                currentTime: 0,
                duration: 0,
                max: 100,
                SpeedIndex: 1,
                volumecontrol: -1,
                sliderValue: 100,
                fillColor: "#9B6C34",
                trackColor: "#e5d4c0",

                myIconGif: L.icon({
                    //当前播放按钮
                    iconUrl: require("../../static/img/spot-play.png"),
                    iconSize: [30, 30],
                    // imageOffset: new BMap.Size(-25, 0)
                }),
                // viewIconMore: L.icon({
                //     //当前播放按钮
                //     iconUrl: require("../../static/img/sheshi-active.png"),
                //     iconSize: [30, 30],
                //     // imageOffset: new BMap.Size(-25, 0)
                // }),
                myIconPause: L.icon({
                    iconUrl: require("../../static/img/spot-pause.png"),
                    iconSize: [30, 30],
                    //imageOffset: new BMap.Size(-25, 0)
                }),
                dingweiPng: L.icon({
                    className: "dingweipng",
                    iconUrl: require("../../static/img/posimg2.gif"),
                    iconSize: [75, 75],
                }),
                viewIconTag: L.icon({
                    //当前暂停按钮
                    iconUrl: require("../../static/img/tag.png"),
                    iconSize: [20, 20],
                }),
                viewIconTagImg: require("../../static/img/tag.png"),
                reTagImg: require("../../static/img/shihuacao-active.png"),
                viewIconMore: require("../../static/img/sheshi-active.png"),
                viewIcon: require("../../static/img/spot1.png"),
                loadingTxt: "",
                loadingVoice: false,
                isPlaying: false,
                map: "",
                isloading: false,
                isHaderShow: false,
                myAudio: "",
                lineDiv_width: "",
                voiceListsPlay_width: "",
                active: "0",
                viewName: "",
                //uuid: "c1368070bd8343e1a946567edce9e611", //65b3862755cf449bad6d9af7bd734ce8
                // userId: "2",
                uuid: "",
                progressBarIndex: -1,
                userId: "",
                id: "",
                isexplain: false,
                scenicAuxiliary: "",
                scenicsBySUUid: "",
                scenicListArr: [],
                scenicList: [],
                scenicsMarker: [],
                sheshiMarker: [],
                noticeContent: "",
                defaultRadius: "",
                scenicName: "",
                minZoomlevel: "",
                maxZoomlevel: "",
                textLevel: "",
                currentZoom: "",
                dislevel: "",
                intro: "",
                pointRange: "",
                centerLat: "",
                centerLng: "",
                currentScenicsImg: "",
                markers: [],
                markersTag: [],
                markerDivs: [],
                markerDivsTag: [],
                num: -1,
                num2: -1,
                currentPlayIndex: -1,
                prevcurrentIndex: -1,
                markerTxts: "",
                markersArr: [],
                markersTxtArr: [],
                isCurrentPlay: false,
                scenicIcon: "",
                currentLineIndex: -1,
                isMaxActive: false,
                isMinOrMaxHint: false,
                isMinOrMaxHintTxt: "",
                isMinActive: false,
                isMaxActive: false,
                isfadeIn: false,
                linetracksArr: [],
                linetracksLen: 0,
                currentLineIndex: -1,
                distancet: "",
                intervalt: "",
                currentImg: "",
                isCurrentPlaying: 0,
                animatedMarker: "",
                polyline: "",
                myLayerGroup: "",
                markersSheshi: new L.LayerGroup(),
                myLayerTag: new L.LayerGroup(),
                myLayerDivsTag: new L.LayerGroup(),
                myLayerGroup1: new L.LayerGroup(),
                myLayerGroup2: new L.LayerGroup(),
                myLayerGroup3: new L.LayerGroup(),
                myLayerGroup4: new L.LayerGroup(),
                ismodelActive: true,
                isVoiceListsShow: false,
                isSliderActive: false,
                islocation: false,
                isPlayIndex: -1,
                playOrpause: 0,
                isDisplayR: "none",
                rotateNum: 0,
                allDuration: 0,
                currentDuration: 0,
                minDivLeft: "0px",
                borderYellow: "0px",
                circle: "rect(0, 0, 0, 0)",
                timeTxt: "",
                isPlayOrpause: false,
                ifBool: false,
                currentLat: 0,
                currentLng: 0,
                hear: "",
                isScenicArea: false,
                isSelfMotion: false,
                isInOrOutShow: false,
                isAndroidOrIos: "",
                isPointRangeFn: false,
                currentIconIndex: 0,
                scenicIconFlag: true,
                title: "",
                houtai: "",
                isFooterShow: false,
                timer: "",
                multipleArray: ["0.75", "1.0", "1.25", "1.5", "2.0"],
                multipleIndexTxt: "1.0",
                multipleIndex: 1,
                isBeisuPull: false,
                randomStr: "",
                awardTimer: "",
                isAwardFlag: true,
                awardTxt: "",
                awardOpactiy: false,
                isAnimateLeft: false,
                subDetails: "",
                subDetailsListIndex: -1,
                subDetailsModelFlag: -1,
                isMuseum: false,
                guideMuseum: null,
                guideMuseumNum: 0,
                isMuseumActive: false,
                isNetwork: false,
                isRecognized: 0,
                isShihuacaoActive: false,
                isChEnActive: false,
                isEn: 0,
                popUplist: [],
                tableIndex: null,
                scenicImgurl: "",
                recordUser: [],
                flag: true,
                interval: null,
                polygonList: [],
                legendList: [], // 传说数据
                isollect: 2,
                statusBarHeight: "24",
                Landmark: "",
                scenicSpot: "",
                continuous: false,
                storyList: [],
                guidList: [],
                audioUrl: "",
                scenics: [],
                currentMusic: "",
                progressBar: "",
                progressList: 0,
                audioSrc: "",
                isDragging: false,
                offLineShow: false,
                downloadFileIndex: 1,
                downloadprogress: 0,
                playIndex: "",
                transmitIndex: -1,
                percentNum: 100,
                subscript: -1,
                titleText: "文稿",
                manuscriptShow: false,
                audioScript: "",
                introduction: "",
                draftList: "",
                drafIndex: "",
                speakName: "",
                scenicsRecorder: [],
                Exhibitsindex: 0
            };
        },

        computed: {
            // 计算填充样式
            fillStyle() {
                const percent = ((this.sliderValue - this.min) / (this.max - this.min)) * 100;
                this.percentNum = percent
                console.log('newVal', percent)
                this.$refs.audio.volume = percent / 100; // 控制音量
                return {
                    width: `${percent}%`,
                    backgroundColor: this.fillColor,
                };
            },
            formattedDuration() {
                const minutes = Math.floor(this.duration / 60);
                const seconds = Math.floor(this.duration % 60);
                return `${minutes}:${seconds.toString().padStart(2, '0')}`;
            },
        },
        components: {
            loading,
            museum,
            PopUp,
        },
        mounted: function() {
            console.log(window.location.href, this.$route)
            // this.$nextTick(() => {
            //       setTimeout(() => {
            //         this.updateBackground(); // 延迟确保 DOM 完全渲染
            //       }, 0);
            //     });
            // this.sdk = window.DouyinOpenJSBridge;
            if (window.location.href) {
                this.title = this.$route.query.scenicName
                this.uuid = this.$route.query.uuid
                this.userId = this.$route.query.userId
                this.statusBarHeight = this.$route.query.statusBarHeight
                this.randomStr = this.$route.query.randomStr
                this.downloadFileIndex = this.$route.query.downloadFileIndex
            }
            this.myAudio = this.$refs.music;
            this.myAudio.method = "mute";
            this.lineDiv_width = this.$refs.borderBox.clientWidth * 1; //长线条的横坐标
            this.voiceListsPlay_width = this.$refs.voiceListsPlay.clientWidth;
            // this.iosAndAndroid();
            this.requestMarkers(0);
            this.recommendedLine();
            this.monitorAudioPlay();
            this.$refs.audio.load();
        },
        destroyed() {
            clearInterval(this.awardTimer);
            clearInterval(this.interval);
        },
        watch: {
            currentLat: {
                handler(newVal, oldVal) {
                    console.log('currentLat变化了', newVal, oldVal);
                    if (this.isScenicArea) this.set_polygon();
                },
            },
            // 监听 value 变化，更新 sliderValue
            value(newVal) {

                this.sliderValue = newVal;
            },
            currentTime() {
                this.updateProgress();
            }
        },
        beforeDestroy() {
            // 在这里执行你需要的操作
            console.log('组件即将被销毁');
        },
        created() {
            window.addEventListener("scanCodeResult", this.handleAppScanCode, false)
            window.addEventListener("handleComplete", this.handleAudioComplete, false)
            // window.addEventListener("handleOrientation", this.getLocationInfo, false)
            // window.addEventListener("handleOrientation", this.handleDownloadList, false)
        },
        onBeforeDestroy() {
            window.removeEventListener("scanCodeResult", this.handleAppScanCode)
            window.removeEventListener("handleComplete", this.handleAudioComplete)
            // window.removeEventListener("handleOrientation", this.getLocationInfo)
            // window.removeEventListener("handleOrientation", this.handleDownloadList)
        },

        methods: {
            //博物馆音频列表
            jumpscience(e) {
                const that = this;
                this.$http({
                    url: "https://tmm6.cn/travelwalkman/museum/getMuseumExhibitsByViewId?viewId=" + e,
                    method: "post"
                    // data: options,
                }).then((res) => {
                    console.log(res)
                    if (this.Exhibitsindex == 0) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                        this.progressBarIndex = -1
                    }
                    for (let i in res.ExhibitsList) {
                        res.ExhibitsList[i].viewName = res.ExhibitsList[i].exhibitName
                        res.ExhibitsList[i].scenicsAudios = {
                            audioUrl: res.ExhibitsList[i].exhibitAudio,
                            audioScript: res.ExhibitsList[i].vexhibitType
                        }
                        // res.ExhibitsList[i].scenicsAudios.push({

                        // })
                    }
                    console.log(res.ExhibitsList)
                    this.storyList = res.ExhibitsList
                    this.isexplain = true
                    this.Exhibitsindex = 1
                    // this.scenicAuxiliary = res;
                    // this.scenics = this.scenicAuxiliary.scenics
                    // this.scenicAuxiliaryFn();
                    // if (index != 1) {
                    //     this.scenicsBySUUidFn();
                    // } else {
                    //     this.scenicsBySUUidFnexplain();
                    // }
                    // if (index == 1) {
                    //     this.isCurrentPlay = !this.isCurrentPlay
                    //     this.currentPlayIndex = -1
                    //     this.currentTime = 0;
                    //     this.myAudio.currentTime = 0;
                    //     this.subDetailsModelFlag = -1
                    //     this.markersArr = []
                    //     // this.scenicIconFlag = !this.scenicIconFlag
                    //     var scenicsMarker = this.scenicsMarker;
                    //     let auxiliarysTag = [],
                    //         auxiliarysSc = [];
                    //     for (let i = 0; i < scenicsMarker.length; i++) {
                    //         if (scenicsMarker[i].showType == "sc") {
                    //             auxiliarysSc.push(scenicsMarker[i]);
                    //         } else if (scenicsMarker[i].viewType == "re") {
                    //             auxiliarysSc.push(scenicsMarker[i]);
                    //         } else if (scenicsMarker[i].viewType == "li") {
                    //             auxiliarysSc.push(scenicsMarker[i]);
                    //         } else {
                    //             auxiliarysTag.push(scenicsMarker[i]);
                    //         }
                    //     }
                    //     this.removeLayer();
                    //     this.cutSetMarkerSheshi(this.sheshiMarker); //设置marker点
                    //     var className = ["my-div-iconTag", "div-iconTag"];
                    //     this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                    //     this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
                    // }

                });
            },
            explainshow() {
                if (this.scenicsRecorder == null) {
                    Toast({
                        message: '当前景点没有讲解员',
                        position: 'top',
                        zIndex: 9999
                    });
                    return
                }
                this.speakName = this.scenicName
                this.scenicName = '讲解员列表'
                this.show = true

            },
            overlayClose() {
                this.scenicName = this.speakName
                this.show = false
            },
            //讲解员
            commentatorspeek(e, index) {
                this.chooseIndex = e
                this.show = false
                // let audioId = 0
                // if (localStorage.getItem('audioIndex')) {
                //     this.chooseIndex = localStorage.getItem('audioIndex')
                //     this.chooseIndex = localStorage.getItem('audioIndex')
                //     audioId = localStorage.getItem('audioIndex')
                //     this.loadingTxt = "音频文件切换中...";
                // }
                // this.chooseIndex = e
                const that = this;
                this.$http({
                    url: "https://tmm6.cn/travelwalkman/guideScenics/getScenicsAllMarsByAudioId?uuid=" +
                        this
                        .uuid + '&audioId=' + this.scenicsRecorder[e].audioId,
                    method: "post",
                    // data: options,
                }).then((res) => {

                    console.log(res)
                    this.scenicAuxiliary = res;
                    this.scenics = this.scenicAuxiliary.scenics
                    this.scenicAuxiliaryFn();
                    if (index != 1) {
                        this.scenicsBySUUidFn();
                    } else {
                        this.scenicsBySUUidFnexplain();
                    }
                    if (index == 1) {
                        this.isCurrentPlay = !this.isCurrentPlay
                        this.currentPlayIndex = -1
                        this.currentTime = 0;
                        this.myAudio.currentTime = 0;
                        this.subDetailsModelFlag = -1
                        this.markersArr = []
                        // this.scenicIconFlag = !this.scenicIconFlag
                        var scenicsMarker = this.scenicsMarker;
                        let auxiliarysTag = [],
                            auxiliarysSc = [];
                        for (let i = 0; i < scenicsMarker.length; i++) {
                            if (scenicsMarker[i].showType == "sc") {
                                auxiliarysSc.push(scenicsMarker[i]);
                            } else {
                                auxiliarysTag.push(scenicsMarker[i]);
                            }
                        }
                        this.removeLayer();
                        this.cutSetMarkerSheshi(this.sheshiMarker); //设置marker点
                        var className = ["my-div-iconTag", "div-iconTag"];
                        this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                        this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
                    }

                });

            },
            //获取音频时长
            handleLoadedMetadata() {
                // 获取音频时长
                // this.$refs.audioPlayer.currentTime;
                // const audio = this.$refs.audioPlayer;
                // console.log(audio.paused)
                // if (audio.paused) {
                //     audio.play();
                // } else {
                //     audio.pause();
                // }
                const audioElement = this.$refs.audio;
                this.duration = audioElement.duration;
            },
            //文稿暂停播放
            draftPlay() {
                this.progressBarIndex = this.drafIndex
                if (this.active == 1) {
                    this.audioUrl = this.draftList.audioUrl
                } else {
                    this.audioUrl = this.draftList.scenicsAudios.audioUrl
                }
                // console.log(state.audioUrl)
                if (this.currentMusic === this.audioUrl) {
                    if (this.isPlaying) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                        this.progressBarIndex = -1
                    } else {
                        this.$refs.audio.play().then(() => {
                            this.isPlaying = true;
                        }).catch((error) => {
                            console.error('播放失败:', error);
                        });
                    }
                } else {
                    if (this.isPlaying) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                    }

                    this.currentMusic = this.audioUrl;
                    this.audioSrc = this.audioUrl;
                    this.$refs.audio.load();
                    // 监听 canplaythrough 事件，确保音频已经加载完成
                    this.$refs.audio.addEventListener('canplaythrough', () => {
                        this.$refs.audio.play().then(() => {
                            this.isPlaying = true;
                        }).catch((error) => {
                            console.error('播放失败:', error);
                        });
                    });
                }
            },
            //打开文稿播放器
            occlude() {
                this.manuscriptShow = false
            },
            //切换音频
            switchover(e) {
                if (this.progressBarIndex == this.storyList.length && e == 1) {
                    Toast({
                        message: '当前音频已到底',
                        position: 'top',
                        zIndex: 9999
                    });
                    return
                }
                if (this.progressBarIndex == 0 && e == 0) {
                    Toast({
                        message: '当前音频已是第一首',
                        position: 'top',
                        zIndex: 9999
                    });
                    return
                }
                if (e == 1) {
                    this.progressBarIndex = this.progressBarIndex + 1
                } else {
                    this.progressBarIndex = this.progressBarIndex - 1
                }
                this.draftList = this.storyList[this.progressBarIndex]
                this.drafIndex = this.progressBarIndex
                this.viewName = this.storyList[this.progressBarIndex].viewName
                // console.log(this.storyList, this.progressBarIndex)
                if (this.active == 1) {
                    this.audioUrl = this.storyList[this.progressBarIndex].audioUrl
                } else {
                    this.audioUrl = this.storyList[this.progressBarIndex].scenicsAudios.audioUrl
                }
                if (this.isPlaying) {
                    this.$refs.audio.pause();
                    this.isPlaying = false;
                }
                this.currentMusic = this.audioUrl;
                this.audioSrc = this.audioUrl;
                this.$refs.audio.load();
                // 监听 canplaythrough 事件，确保音频已经加载完成
                this.$refs.audio.addEventListener('canplaythrough', () => {
                    this.$refs.audio.play().then(() => {
                        this.isPlaying = true;
                    }).catch((error) => {
                        console.error('播放失败:', error);
                    });
                });
                // console.log(state.audioUrl)
                // if (this.currentMusic === this.audioUrl) {
                //     if (this.isPlaying) {
                //         this.$refs.audio.pause();
                //         this.isPlaying = false;
                //         this.progressBarIndex = -1
                //     } else {
                //         this.$refs.audio.play().then(() => {
                //             this.isPlaying = true;
                //         }).catch((error) => {
                //             console.error('播放失败:', error);
                //         });
                //     }
                // } else {
                // }
                setTimeout(() => {
                    this.handleLoadedMetadata();
                }, 500)
            },
            formatTime(time) {
                const minutes = Math.floor(time / 60);
                const seconds = Math.floor(time % 60);
                return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            },
            onInputChange(event) {
                this.currentTime = parseFloat(event.target.value);
                this.$refs.audio.currentTime = this.currentTime;
            },
            updateProgress() {
                const progress = (this.currentTime / this.duration) * 100;
                document.querySelector('.progress-bar').style.setProperty('--progress', `${progress}%`);
            },
            onTimeUpdate() {
                this.currentTime = this.$refs.audio.currentTime;
                this.updateProgress();
            },
            manuscript(e, index) {
                this.draftList = e
                this.drafIndex = index
                console.log(e)
                this.viewName = e.viewName
                this.manuscriptShow = true
                this.audioScript = e.scenicsAudios.audioScript
                this.audioSrc = e.scenicsAudios.audioUrl
                this.handleLoadedMetadata();
            },
            playbackvolume(e) {
                this.volumecontrol = e
            },
            // 更新填充
            updateFill() {
                this.$emit("input", this.sliderValue);
            },
            //音频下载完成
            handleAudioComplete() {
                this.downloadFileIndex = 2
            },
            //音频下载进度
            handleAppScanCode() {
                this.downloadprogress = window.appScanCodeResultString
            },
            //下载
            downloadFile() {
                if (this.downloadFileIndex == 2) {
                    Toast({
                        message: '当前音频已下载',
                        position: 'top',
                        zIndex: 9999
                    });
                    return
                }
                if (this.downloadFileIndex == 3) {
                    Toast({
                        message: '当前暂无可下载的音频',
                        position: 'top',
                        zIndex: 9999
                    });
                    return
                }
                if (this.downloadFileIndex == 0) {
                    uni.postMessage({
                        data: {
                            action: 'suspend',
                        }
                    });
                    return
                }
                // console.log(state.facilities)
                let list = []
                let listArray = []
                let guidArray = []
                // list.push(state.facilities[0])
                // list.push(state.facilities[1])
                // guidArray.push({
                // 	scenicsAudios: {
                // 		audioUrl: 'http://39.99.244.118:80/group1/M00/00/C9/rBYzEmXpqHqAED6BAClVa5fJONs068.MP3',
                // 		scenicName: "故宫博物院",
                // 		viewName: "故宫的门槛被谁锯了"
                // 	}
                // })
                // guidArray.push({
                // 	scenicsAudios: {
                // 		audioUrl: 'http://39.99.244.118:80/group1/M00/00/C9/rBYzEmXpqHqAED6BAClVa5fJONs068.MP3',
                // 		scenicName: "故宫博物院",
                // 		viewName: "康熙粉彩大果盘的故事"
                // 	}
                // })
                // console.log('当前音频已下载', state.facilities)
                let facilities = JSON.stringify(this.scenics)
                this.downloadFileIndex = 0
                // console.log('guidList', state.guidList)
                this.guidList.map((item, index) => {
                    guidArray.push({
                        scenicsAudios: {
                            audioUrl: item.audioUrl,
                            scenicName: item.scenicName,
                            viewName: item.viewName
                        }
                    })
                })
                // console.log('aaaa',list,guidArray)
                listArray.push({
                    guideScenics: JSON.stringify(this.scenicsBySUUid.guideScenics),
                    facilities: facilities,
                    guidList: JSON.stringify(guidArray)
                })
                // uni.postMessage({
                // 	data: {
                // 		action: 'guideScenics',
                // 		data: state.scenicsBySUUid.guideScenics
                // 	}
                // });
                // localStorage.setItem('facilities', facilities)
                // console.log('传递的数组', listArray)
                uni.postMessage({
                    data: {
                        action: 'download',
                        data: listArray
                    }
                });
                // downloadAllAudios()
                // localStorage.setItem('guidList', JSON.stringify(state.guidList))
                // for (let i = 0; i < state.facilities.length; i++) {
                // 	try {
                // 		const response = await axios({
                // 			url: state.facilities[i],
                // 			method: 'GET',
                // 			responseType: 'blob'
                // 		});
                // 		const blob = response.data;
                // 		const url = URL.createObjectURL(blob);
                // 		const a = document.createElement('a');
                // 		a.href = url;
                // 		a.download = `audio${i + 1}.mp3`;
                // 		document.body.appendChild(a);
                // 		a.click();
                // 		document.body.removeChild(a);
                // 		URL.revokeObjectURL(url);
                // 	} catch (error) {
                // 		console.error(`下载第${i + 1}个音频文件失败：`, error);
                // 	}
                // }
            },
            //离线包下载
            offLine() {
                this.offLineShow = true
                console.log(this.$route.query.downloadFileIndex)
                if (this.$route.query.downloadFileIndex == 2) {
                    Toast({
                        message: '当前音频已下载',
                        position: 'top',
                        zIndex: 9999
                    });
                    this.downloadFileIndex = 2
                }
            },
            //关闭离线包遮罩
            suspendLine() {
                this.offLineShow = false
            },
            //音频播放
            startDrag(event) {
                this.isDragging = true;
                document.addEventListener('mousemove', drag);
                document.addEventListener('mouseup', stopDrag);
                this.drag(event);
            },
            //音频播放
            drag(event) {
                if (this.isDragging) {
                    this.seek(event);
                }
            },
            //音频播放
            stopDrag() {
                this.isDragging = false;
                document.removeEventListener('mousemove', drag);
                document.removeEventListener('mouseup', stopDrag);
            },
            // 进度条更新
            updateProgressList() {
                if (!this.isDragging) {
                    this.progressList = (this.$refs.audio.currentTime / this.$refs.audio.duration) * 100
                    this.currentTime = this.$refs.audio.currentTime;
                }
            },
            //播放完毕
            onAudioEnded() {
                console.log('播放完毕')
                // console.log('播放完毕', state.progressBarIndex + 1, state.progressBarIndex)
                this.isPlaying = false
                if (this.continuous) {
                    this.progressList = 0
                    this.togglePlay(this.storyList[this.progressBarIndex + 1], this
                        .progressBarIndex + 1)
                }
            },
            //点击跳转进度时间
            seek(event) {
                const rect = this.$refs.progressBar.getBoundingClientRect();
                const offsetX = event.clientX - rect.left;
                const percentage = (offsetX / rect.width) * 100;
                this.$refs.audio.currentTime = (percentage / 100) * this.$refs.audio.duration;
                this.progressList = percentage;
            },
            //点击跳转进度时间
            seekdraft(event) {
                if (this.isDragging) {
                    return
                }
                const rect = this.$refs.progressBar_box.getBoundingClientRect();
                const offsetX = event.clientX - rect.left;
                const percentage = (offsetX / rect.width) * 100;
                this.$refs.audio.currentTime = (percentage / 100) * this.$refs.audio.duration;
                this.progressList = percentage;
            },
            //点击音乐播放暂停
            togglePlay(e, index) {
                this.progressBarIndex = index
                if (this.active == 1) {
                    this.audioUrl = e.audioUrl
                } else {
                    this.audioUrl = e.scenicsAudios.audioUrl
                }
                console.log(this.isCurrentPlay)
                if (!this.isCurrentPlay && this.isPlayIndex != -1) {
                    // 播放中
                    this.playOrpause = 0; // 底部按钮是播放中还是暂停中
                    this.isCurrentPlay = true; // 保存当前播放的状态
                    if (this.scenicIconFlag) {
                        this.markersArr[this.isPlayIndex].setIcon(this.myIconPause); // 设置 marker 图标为暂停按钮
                        this.markers.refreshClusters(); // 刷新 marker 点
                        this.markerDivs.refreshClusters(); // 刷新 marker 点下文字点
                    }
                    if (this.currentTime == 0) {
                        const audioUrlCE = this.isChEnActive ? scenicsAudios.enAudioUrl : scenicsAudios.audioUrl;
                        this.myAudio.src = audioUrlCE; // 播放当前语音
                        this.myAudioSrc = audioUrlCE;
                    }
                    this.myAudio.pause();
                }
                // console.log(state.audioUrl)
                if (this.currentMusic === this.audioUrl) {
                    if (this.isPlaying) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                        this.progressBarIndex = -1
                    } else {
                        this.$refs.audio.play().then(() => {
                            this.isPlaying = true;
                        }).catch((error) => {
                            console.error('播放失败:', error);
                        });
                    }
                    console.log('获取音频播放状态1', this.isPlaying)
                } else {
                    console.log('获取音频播放状态2', this.isPlaying)
                    if (this.isPlaying) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                    }

                    this.currentMusic = this.audioUrl;
                    this.audioSrc = this.audioUrl;
                    this.$refs.audio.load();
                    // 监听 canplaythrough 事件，确保音频已经加载完成
                    this.$refs.audio.addEventListener('canplaythrough', () => {
                        this.$refs.audio.play().then(() => {
                            this.isPlaying = true;
                        }).catch((error) => {
                            console.error('播放失败:', error);
                        });
                    });
                }
            },
            //讲解员列表
            isexplainClose() {
                this.isexplain = false
            },
            //切换播放列表
            tabsBox(e) {
                console.log(e)
                if (this.isPlaying) {
                    this.$refs.audio.pause();
                    this.isPlaying = false;
                    this.audioUrl = ''
                }
                this.progressBarIndex = -1
                if (this.active == '0') {
                    this.storyList = this.scenics

                } else {
                    this.storyList = this.guidList
                }
            },
            //控制播放速度
            playbackSpeed(e) {
                this.subscript = e
                if (this.SpeedIndex < 2) {
                    this.SpeedIndex += 0.5
                } else {
                    this.SpeedIndex = 1
                }
                const audio = document.getElementById("myAudio");
                audio.playbackRate = this.SpeedIndex;
            },
            // getIsCollect(){
            //   const options = {
            //     uuid: this.uuid,
            //     userId: this.userId,
            //   };
            //   this.$http({
            //     url: `https://tumaomao.miaodonglvxing.com/travelwalkman/guideScenics/getScenicsByScenicsByUUid`,
            //     method: "get",
            //     params: options,
            //   }).then((res) => {
            //      console.log(res);
            //   });
            // },
            onClickCollect() {
                this.isollect = this.isollect == 1 ? 2 : 1;
                this.isInOrOutShow = false;
                const options = {
                    uuid: this.uuid,
                    userId: this.userId,
                    name: this.title,
                    img: this.scenicImgurl,
                    intro: this.scenicsBySUUid.guideScenics.intro,
                    type: this.isollect,
                };
                const that = this;
                this.$http({
                    url: "https://www.tmm6.cn/travelwalkman/recordCollect/recordCollect",
                    method: "post",
                    data: options,
                }).then((res) => {
                    if (that.isollect === 1) {
                        that.isInOrOutShow = true;
                        that.InOrOutTxt = "收藏成功";
                    } else {
                        that.isInOrOutShow = true;
                        that.InOrOutTxt = "取消收藏";
                    }
                    setTimeout(() => {
                        that.isInOrOutShow = false;
                        that.InOrOutTxt = "";
                    }, 2000);
                });
            },
            set_polygon() {
                let arrlist = JSON.parse(JSON.stringify(this.scenicsMarker));
                // 清空旧图形
                if (this.polygonList.length > 0) {
                    this.polygonList.forEach((item) => {
                        if (item && item.remove) {
                            item.remove(); // 从地图中移除图形
                        }
                    });
                    this.polygonList = []; // 清空数组
                }
                // 计算距离并排序
                arrlist = arrlist
                    .map((item) => {
                        item = {
                            ...item,
                            distance: calcDistance(
                                this.currentLat,
                                this.currentLng,
                                JSON.parse(item.lat)[0],
                                JSON.parse(item.lat)[1]
                            ),
                        };
                        return item;
                    })
                    .sort((a, b) => a.distance - b.distance)
                    .slice(0, 2);
                // this.map.removeLayer();
                // 绘制新图形
                arrlist.forEach((element) => {
                    if (element.scenicsAudios) {
                        var point = JSON.parse(element.lat);
                        if (element.scenicsAudios.lat != null) {
                            const params = JSON.parse(element.scenicsAudios.lat);
                            const polygon = L.polygon(params, {
                                color: "red",
                                weight: 1
                            });
                            this.polygonList.push(polygon);
                            polygon.addTo(this.map); // 确保添加到地图
                        } else {
                            const circle = L.circle(point, element.scenicsAudios.radius || 20, {
                                color: "red", // 边框颜色
                                fillColor: "red", // 内部填充颜色
                                fillOpacity: 0.3,
                            });
                            this.polygonList.push(circle);
                            circle.addTo(this.map); // 确保添加到地图
                        }
                    }
                });
                this.polygonList.forEach((item) => item.addTo(this.map));
                // this.isSelfMotionFn(this.scenicsMarker);
            },
            audioAutoPlay(id) {
                var audio = document.getElementById(id);
                var play = function() {
                    document.removeEventListener("WeixinJSBridgeReady", play);
                    audio.play();
                    audio.pause();
                };
                // audio.play();
                // audio.pause();
                //weixin
                document.addEventListener("WeixinJSBridgeReady", play, false);
            },
            ChEnSwitchFn() {
                this.isChEnActive = !this.isChEnActive;
                this.currentTime = 0;
                this.myAudio.currentTime = 0;
                if (!this.isCurrentPlay && this.isPlayIndex != -1) {
                    const {
                        scenicsAudios
                    } = this.scenicsMarker[this.isPlayIndex];
                    const audioUrlCE = this.isChEnActive ?
                        scenicsAudios.enAudioUrl :
                        scenicsAudios.audioUrl;
                    //console.log(audioUrlCE)
                    this.myAudio.src = audioUrlCE; //b播放当前语音
                    this.myAudioSrc = audioUrlCE;
                    this.myAudio.play();
                }
                this.markersArr = [];
                this.markersTxtArr = [];
                this.ismodelActive = false;
                this.scenicIconFlag = true;
                clearTimeout(this.timer);
                this.removeLayer();
                const auxiliarysSc = this.scenicsMarker.filter((item) => {
                    if (this.isChEnActive) {
                        return item.showType == "sc" && item.enViewName != null;
                    } else {
                        return item.showType == "sc";
                    }
                });
                const auxiliarysTag = this.scenicsMarker.filter(
                    (item) => item.showType != "sc"
                );
                var className = ["my-div-iconTag", "div-iconTag"];
                this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
            },
            func(data) {
                this.isMuseum = data;
                this.isMuseumActive = false;
                this.isShihuacaoActive = false;
            },
            closedFn(data) {
                this.isloading = data;
            },
            // shareMessage() {
            // 	var that = this;
            // 	wx.ready(function() {
            // 		wx.hideMenuItems({
            // 			menuList: [
            // 				"menuItem:share:qq",
            // 				"menuItem:share:weiboApp",
            // 				"menuItem:share:facebook",
            // 				"menuItem:share:QZone",
            // 				"menuItem:editTag",
            // 				"menuItem:delete",
            // 				"menuItem:copyUrl",
            // 				"menuItem:originPage",
            // 				"menuItem:readMode",
            // 				"menuItem:openWithQQBrowser",
            // 				"menuItem:openWithSafari",
            // 				"menuItem:share:email",
            // 				"menuItem:share:brand",
            // 			], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
            // 		});
            // 		wx.onMenuShareTimeline({
            // 			//分享到朋友圈
            // 			title: that.title, // 分享标题
            // 			link: "https://www.tmm6.cn/travelwalkman/order/tb/toBScenicsIndex?uuid=" +
            // 				that.uuid, // 分享链接
            // 			imgUrl: that.scenicImgurl, // 分享图标
            // 			success: function() {
            // 				// 用户确认分享后执行的回调函数
            // 				//alert('分享朋友圈')
            // 			},
            // 			cancel: function() {
            // 				// 用户取消分享后执行的回调函数
            // 			},
            // 		});
            // 		wx.onMenuShareAppMessage({
            // 			title: that.title, // 分享标题
            // 			desc: "智慧景区导览", // 分享描述
            // 			link: "https://www.tmm6.cn/travelwalkman/order/tb/toBScenicsIndex?uuid=" +
            // 				that.uuid, // 分享链接
            // 			imgUrl: that.scenicImgurl, // 分享图标
            // 			success: function() {},
            // 			cancel: function() {
            // 				// 用户取消分享后执行的回调函数
            // 			},
            // 		});
            // 	});
            // },
            iosAndAndroid() {
                //判断是ios 还是Android
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    this.isAndroidOrIos = "android";
                }
                if (isIOS) {
                    this.isAndroidOrIos = "ios";
                }
            },
            requestMarkers(e, index) {
                console.log(e)
                if (index == 1) {
                    this.commentatorspeek(e, index)
                    return
                    // localStorage.setItem('audioIndex', e)
                    // const currentPath = this.$route.fullPath;
                    // this.$router.replace({
                    //     path: '/redirect'
                    // }).then(() => {
                    //     this.$router.replace(currentPath + '?t=' + Date.now());
                    // });
                }
                this.isloading = this.$store.state.isLoading = true;
                if (this.show == true) {
                    this.show = false
                }

                this.loadingTxt = "数据加载中...";
                this.loadingVoice = false;
                var qs = require("qs");
                var ops = {
                    uuid: this.uuid,
                    audioId: 0
                };
                var ops1 = {
                    uuid: this.uuid,
                    userId: this.userId,
                };
                Promise.all([
                    this.$http.post("/getScenicsAllMars", qs.stringify(ops)),
                    this.$http.post("/getScenicsByScenicsByUUid", qs.stringify(ops1)),
                    this.$http.get(`/getGuideStory?uuid=${this.uuid}`),
                    this.$http.post("/getScenicsAllMarsByAudioId", qs.stringify(ops)),
                ]).then(
                    (res) => {
                        this.scenicsRecorder = res[1].scenicsRecorder
                        if (this.scenicsRecorder != null) {
                            console.log('获取lire',res[0])
                            this.scenicsBySUUid = res[1];
                            this.isollect = this.scenicsBySUUid.recordCollect ? 1 : 2;
                            this.scenicImgurl = res[1].guideScenics.imgurl;
                            this.legendList = res[2].list;
                            this.guidList = res[2].list;
                            this.scenicSpot = '故事' + `(${res[2].list.length}个)`
                            this.commentatorspeek(e)
                        } else {
                            console.log('获取li',res[0])
                            this.scenicAuxiliary = res[0];
                            this.scenicsBySUUid = res[1];
                            this.isollect = this.scenicsBySUUid.recordCollect ? 1 : 2;
                            this.scenicImgurl = res[1].guideScenics.imgurl;
                            this.legendList = res[2].list;
                            this.guidList = res[2].list;
                            this.scenics = this.scenicAuxiliary.scenics
                            this.scenicSpot = '故事' + `(${res[2].list.length}个)`
                            this.scenicAuxiliaryFn();
                            this.scenicsBySUUidFn();
                        }
                    },
                    (error) => {
                        this.isloading = this.$store.state.isLoading = false;
                        this.loadingTxt = "";
                        this.isInOrOutShow = true;
                        this.InOrOutTxt = "网络出错，请退出重试！";
                        setTimeout(() => {
                            this.isInOrOutShow = false;
                            this.InOrOutTxt = "";
                            this.isNetwork = true;
                        }, 2500);
                    }
                );
            },
            reloadFn() {
                this.isNetwork = false;
                this.requestMarkers();
            },
            scenicAuxiliaryFn() {
                if (this.scenicAuxiliary.state == "200") {
                    this.scenicsMarker = this.scenicAuxiliary.scenics;
                    console.log('景点',this.scenicAuxiliary)
                    this.storyList = this.scenicAuxiliary.scenics;

                    this.Landmark = `景点(${this.storyList.length}个)`
                    this.sheshiMarker = this.scenicAuxiliary.facilities;
                }
            },
            scenicsBySUUidFn() {
                if (this.scenicsBySUUid.state == "200") {
                    //console.log(this.scenicsBySUUid);
                    //this.userId = this.scenicsBySUUid.userId;
                    var guideScenics = this.scenicsBySUUid.guideScenics;
                    if (guideScenics.notice != null && guideScenics.notice != "") {
                        this.noticeContent = guideScenics.notice;
                    }
                    let subDetails = guideScenics.subDetails;
                    if (subDetails != null && subDetails != "") {
                        this.subDetails = JSON.parse(subDetails);
                    } else {
                        this.subDetails = null;
                    }
                    console.log(guideScenics);
                    this.isRecognized = guideScenics.isRecognized;
                    this.isEn = guideScenics.isEn;
                    this.guideMuseum = this.scenicsBySUUid.guideMuseum;
                    this.guideMuseumNum = this.scenicsBySUUid.guideMuseumNum;
                    this.id = guideScenics.id;
                    this.rescuetel = guideScenics.rescuetel;
                    this.defaultRadius = guideScenics.defaultRadius * 1;
                    this.scenicName = guideScenics.scenicName;
                    //	this.scenicName = guideScenics.enViewName;
                    this.minZoomlevel = guideScenics.zoomlevel.split(",")[0] * 1;
                    this.maxZoomlevel = guideScenics.zoomlevel.split(",")[1] * 1;
                    this.textLevel = JSON.parse(guideScenics.textzoomlevel).textLevel * 1;
                    this.distancet = JSON.parse(guideScenics.textzoomlevel).distance;
                    this.intervalt = JSON.parse(guideScenics.textzoomlevel).interval;
                    this.currentZoom =
                        JSON.parse(guideScenics.textzoomlevel).currentZoom * 1;
                    this.dislevel = guideScenics.dislevel;
                    this.uuid = guideScenics.uuid;
                    this.intro = eval(guideScenics.intro);
                    this.pointRange = JSON.parse(guideScenics.imgbounds);
                    this.currentLocationFn();
                    //this.shareMessage();
                }
            },
            scenicsBySUUidFnexplain() {
                if (this.scenicsBySUUid.state == "200") {
                    //console.log(this.scenicsBySUUid);
                    //this.userId = this.scenicsBySUUid.userId;
                    var guideScenics = this.scenicsBySUUid.guideScenics;
                    if (guideScenics.notice != null && guideScenics.notice != "") {
                        this.noticeContent = guideScenics.notice;
                    }
                    let subDetails = guideScenics.subDetails;
                    if (subDetails != null && subDetails != "") {
                        this.subDetails = JSON.parse(subDetails);
                    } else {
                        this.subDetails = null;
                    }
                    console.log(guideScenics);
                    this.isRecognized = guideScenics.isRecognized;
                    this.isEn = guideScenics.isEn;
                    this.guideMuseum = this.scenicsBySUUid.guideMuseum;
                    this.guideMuseumNum = this.scenicsBySUUid.guideMuseumNum;
                    this.id = guideScenics.id;
                    this.rescuetel = guideScenics.rescuetel;
                    this.defaultRadius = guideScenics.defaultRadius * 1;
                    this.scenicName = guideScenics.scenicName;
                    //	this.scenicName = guideScenics.enViewName;
                    this.minZoomlevel = guideScenics.zoomlevel.split(",")[0] * 1;
                    this.maxZoomlevel = guideScenics.zoomlevel.split(",")[1] * 1;
                    this.textLevel = JSON.parse(guideScenics.textzoomlevel).textLevel * 1;
                    this.distancet = JSON.parse(guideScenics.textzoomlevel).distance;
                    this.intervalt = JSON.parse(guideScenics.textzoomlevel).interval;
                    this.currentZoom =
                        JSON.parse(guideScenics.textzoomlevel).currentZoom * 1;
                    this.dislevel = guideScenics.dislevel;
                    this.uuid = guideScenics.uuid;
                    this.intro = eval(guideScenics.intro);
                    this.pointRange = JSON.parse(guideScenics.imgbounds);
                    //this.shareMessage();
                }
            },
            currentLocationFn() {
                //j计算当前中心位置坐标
                var pointRange = this.pointRange;
                var lat =
                    ((pointRange[1][0] - pointRange[0][0]) / 2).toFixed(10) * 1 +
                    pointRange[0][0];
                var lng =
                    ((pointRange[1][1] - pointRange[0][1]) / 2).toFixed(10) * 1 +
                    pointRange[0][1];
                this.centerLat = lat;
                this.centerLng = lng;
                this.createMap(lat, lng);
            },
            createMap(lat, lng) {
                console.log(this.currentZoom)
                if (!this.currentZoom) {
                    this.currentZoom = 17
                }
                console.log(this.currentZoom)
                var corner1 = L.latLng(this.pointRange[0][0], this.pointRange[0][1]), //设置左上角经纬度
                    corner2 = L.latLng(this.pointRange[1][0], this.pointRange[1][1]), //设置右下点经纬度
                    pointRange = L.latLngBounds(corner1, corner2); //构建视图限制范围
                if (!this.map) {
                    this.map = L.map(this.$refs.allmap, {
                        //创建地图
                        center: [lat, lng],
                        zoomControl: false,
                        attributionControl: false,
                        trackResize: true,
                        doubleClickZoom: false,
                        layers: [],
                        zoom: this.currentZoom, //当前缩放级别
                        minZoom: this.minZoomlevel, //最大缩放级别
                        maxZoom: this.maxZoomlevel, //最小缩放级别
                        maxBounds: pointRange,
                    });
                }

                this.map.addEventListener("click", () => {
                    this.isAnimateLeft = !this.isAnimateLeft;
                    if (this.subDetailsModelFlag == -1) {
                        this.subDetailsModelFlag = -1;
                    } else {
                        this.subDetailsModelFlag = 1;
                    }
                });
                var imageUrl =
                    "https://www.tmm6.cn/travelwalkman/imgs/" +
                    this.uuid +
                    "/" +
                    this.id +
                    ".jpg?v=" +
                    new Date().getTime(),
                    imageBounds = this.pointRange;
                var img1 = new Image();
                img1.src = imageUrl;
                this.isloading = this.$store.state.isLoading = true;
                this.loadingTxt = "图片加载中...";
                this.loadingVoice = false;
                let that = this
                img1.onload = () => {
                    L.imageOverlay(imageUrl, imageBounds, {
                        zIndex: 1,
                    }).addTo(this.map); //设置图片
                    this.getCurrentPos(1); //获取当前地理位置
                    this.isloading = this.$store.state.isLoading = false;
                    setTimeout(() => {
                        this.loadingTxt = "数据加载中...";
                    }, 500);
                };
                img1.onerror = () => {
                    console.log("图片加载失败，加载备用底图");
                    // this.createTileLayer()
                    // 停止加载状态
                    this.isloading = this.$store.state.isLoading = false;

                    setTimeout(() => {
                        this.loadingTxt = "数据加载中...";
                    }, 500);

                    // 移除可能已添加的图片图层
                    this.map.eachLayer((layer) => {
                        if (layer instanceof L.ImageOverlay) {
                            this.map.removeLayer(layer);
                        }
                    });
                    const tileLayer = L.tileLayer(
                        'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}', {
                            tms: false, // 如果服务器需要 TMS 格式
                        }
                    ).addTo(this.map);
                    // 加载备用瓦片图层
                    // const tileLayer = L.tileLayer(
                    //     'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    //         tms: true, // 如果服务器需要 TMS 格式
                    //     }
                    // ).addTo(this.map);
                    // const tileLayer = L.tileLayer(
                    //     'https://{s}.googleapis.com/maps/vt?lyrs=m&x={x}&y={y}&z={z}', {
                    //         subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
                    //     }
                    // ).addTo(this.map);
                    // const tileLayer = L.tileLayer(
                    //     'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
                    //         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
                    //     }
                    // ).addTo(this.map);
                    // const tileLayer = L.tileLayer(
                    //     'https://{s}.tile.openmaptiles.org/{z}/{x}/{y}.png', {
                    //         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    //     }
                    // ).addTo(this.map);
                    // 监听瓦片加载失败事件
                    tileLayer.on('tileerror', (error, tile) => {
                        console.error('瓦片加载失败:', error);
                        console.log('失败的瓦片 URL:', tile.src);
                        // this.createTileLayer()
                        // 可以在这里处理错误，比如显示备用图层或提示用户
                    });
                };

                // img1.onerror = () => {
                //     console.log("图片加载失败，加载备用底图");
                //     // 停止加载状态
                //     this.isloading = this.$store.state.isLoading = false;

                //     setTimeout(() => {
                //         this.loadingTxt = "数据加载中...";
                //     }, 500);

                //     // 移除可能已添加的图片图层
                //     this.map.eachLayer((layer) => {
                //         if (layer instanceof L.ImageOverlay) {
                //             this.map.removeLayer(layer);
                //         }
                //     });
                //     // const {
                //     // 	lat,
                //     // 	lng
                //     // } = this.map.getCenter(); // 获取地图中心点
                //     // const z = this.map.getZoom(); // 获取当前缩放级别

                //     // const x = Math.floor((lng + 180) / 360 * (1 << z)); // 计算 x
                //     // const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat *
                //     // 	Math.PI / 180)) / Math.PI) / 2 * (1 << z)); // 计算 y

                //     // console.log(`当前中心点瓦片坐标：x=${x}, y=${y}, z=${z}`);
                //     // 加载备用瓦片图层
                //     const tileLayer = L.tileLayer(
                //         'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}', {
                //             tms: false, // 如果服务器需要 TMS 格式
                //         }
                //     ).addTo(this.map);
                //     console.log(tileLayer)
                // };
                var scenicsMarker = this.scenicsMarker;
                let auxiliarysTag = [],
                    auxiliarysSc = [];
                for (let i = 0; i < scenicsMarker.length; i++) {
                    if (scenicsMarker[i].showType == "sc") {
                        auxiliarysSc.push(scenicsMarker[i]);
                    } else {
                        auxiliarysTag.push(scenicsMarker[i]);
                    }
                }
                console.log('获取masker点是li的', this.scenicsMarker)
                this.cutSetMarkerSheshi(this.sheshiMarker); //设置marker点
                var className = ["my-div-iconTag", "div-iconTag"];
                this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
            },
            createTileLayer() {
                //自定义瓦片
                var that = this;
                var tileLayers = new L.tileLayer({
                    isTransparentPng: true,
                });
                tileLayers.getTileUrl = function(tileCoord, zoom) {
                    var x = tileCoord.x;
                    var y = tileCoord.y;
                    return (
                        "http://www.1314zhilv.com/imgs/tiles/" +
                        that.uuid +
                        "/" +
                        that.currentZoom +
                        "/" +
                        x +
                        "_" +
                        y +
                        ".png?v=" +
                        new Date().getTime()
                    ); //根据当前坐标，选取合适的瓦片图
                };
                tileLayers.type = 'vec'; // 设置瓦片图层类型
                this.map.addLayer(tileLayers);
            },
            getLocationFn() {
                let that = this
                // 调用 getCurrentPosition 方法
                navigator.geolocation.getCurrentPosition(
                    // 成功回调
                    function(position) {
                        const latitude = position.coords.latitude; // 纬度
                        const longitude = position.coords.longitude; // 经度
                        const accuracy = position.coords.accuracy; // 精度（以米为单位）
                        const location = WGS84ToGCJ02.wgs84ToGcj02(longitude, latitude)
                        console.log('转换后的经纬度2', location)
                        that.currentLat = location[1]
                        that.currentLng = location[0]
                    },
                    // 失败回调
                    function(error) {

                    },
                    // 定位选项（可选）
                    {
                        enableHighAccuracy: true, // 尽可能获取高精度结果
                        timeout: 5000, // 超时时间（毫秒）
                        maximumAge: 0, // 禁止缓存
                    }
                );
                // var that = this;
                // wx.ready(function() {
                // 	wx.getLocation({
                // 		type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                // 		success: function(res) {
                // 			var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // 			var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // 			// //var lngLat = that.gcj02tobd09(longitude, latitude);
                // 			that.currentLat = latitude;
                // 			that.currentLng = longitude;
                // 		},
                // 	});
                // });
            },
            getCurrentPoseeeee(mark, index) {
                let that = this
                const latitude = 39.919515453 // 纬度
                const longitude = 116.388829056 // 经度
                const location = WGS84ToGCJ02.wgs84ToGcj02(longitude, latitude)
                console.log('转换后的经纬度', location)
                that.currentLat = location[1]
                that.currentLng = location[0]
                if (that.hear != "") {
                    that.map.removeLayer(that.hear);
                }
                that.scenicAreaFn(that.currentLat, that.currentLng);
                that.hear = L.marker([that.currentLat * 1, that.currentLng * 1], {
                    icon: that.dingweiPng,
                }).addTo(that.map);
                return
                // 调用 getCurrentPosition 方法
                navigator.geolocation.getCurrentPosition(
                    // 成功回调
                    function(position) {
                        const latitude = position.coords.latitude; // 纬度
                        const longitude = position.coords.longitude; // 经度
                        const accuracy = position.coords.accuracy; // 精度（以米为单位）
                        const location = WGS84ToGCJ02.wgs84ToGcj02(longitude, latitude)
                        console.log('转换后的经纬度', location)
                        that.currentLat = location[1]
                        that.currentLng = location[0]
                        if (that.hear != "") {
                            that.map.removeLayer(that.hear);
                        }
                        that.scenicAreaFn(that.currentLat, that.currentLng);
                        that.hear = L.marker([that.currentLat * 1, that.currentLng * 1], {
                            icon: that.dingweiPng,
                        }).addTo(that.map);
                        // if(mark == 0) {
                        // 	var zoom = that.map.getZoom()
                        // 	that.map.setView(L.latLng(that.currentLat* 1,that.currentLng* 1),zoom)
                        // }
                        var qs = require("qs");
                        var ops = {
                            guideScId: that.uuid,
                            userid: that.userId,
                            lat: that.currentLat,
                            lng: that.currentLng,
                            type: mark,
                        };
                        that.$http
                            .post("/saveUserPosition", qs.stringify(ops))
                            .then((res) => {
                                console.log(res);
                            });
                        console.log(`
				            纬度：${latitude}
				            经度：${longitude}
				          `)
                    },
                    // 失败回调
                    function(error) {
                        console.log(error);
                        clearInterval(that.realTimer);
                        if (that.hear != "") {
                            that.map.removeLayer(that.hear);
                        }
                        that.map.removeLayer(that.hear);
                        that.isSelfMotion = true;
                        that.isSliderActive = false;
                        Toast("定位失败,请重新开启定位！");
                    },
                    // 定位选项（可选）
                    {
                        enableHighAccuracy: true, // 尽可能获取高精度结果
                        timeout: 5000, // 超时时间（毫秒）
                        maximumAge: 0, // 禁止缓存
                    }
                );
            },
            getCurrentPos(mark, index) {
                let that = this
                // const latitude = 39.919059565 // 纬度
                // const longitude = 116.390694901 // 经度
                // const location = WGS84ToGCJ02.wgs84ToGcj02(longitude, latitude)
                // console.log('转换后的经纬度', location)
                // that.currentLat = location[1]
                // that.currentLng = location[0]
                // if (that.hear != "") {
                // 	that.map.removeLayer(that.hear);
                // }
                // that.scenicAreaFn(that.currentLat, that.currentLng);
                // that.hear = L.marker([that.currentLat * 1, that.currentLng * 1], {
                // 	icon: that.dingweiPng,
                // }).addTo(that.map);
                // return
                // 调用 getCurrentPosition 方法
                navigator.geolocation.getCurrentPosition(
                    // 成功回调
                    function(position) {
                        const latitude = position.coords.latitude; // 纬度
                        const longitude = position.coords.longitude; // 经度
                        const accuracy = position.coords.accuracy; // 精度（以米为单位）
                        const location = WGS84ToGCJ02.wgs84ToGcj02(longitude, latitude)
                        console.log('转换后的经纬度', location)
                        that.currentLat = location[1]
                        that.currentLng = location[0]
                        if (that.hear != "") {
                            that.map.removeLayer(that.hear);
                        }
                        that.scenicAreaFn(that.currentLat, that.currentLng);
                        that.hear = L.marker([that.currentLat * 1, that.currentLng * 1], {
                            icon: that.dingweiPng,
                        }).addTo(that.map);
                        // if(mark == 0) {
                        // 	var zoom = that.map.getZoom()
                        // 	that.map.setView(L.latLng(that.currentLat* 1,that.currentLng* 1),zoom)
                        // }
                        var qs = require("qs");
                        var ops = {
                            guideScId: that.uuid,
                            userid: that.userId,
                            lat: that.currentLat,
                            lng: that.currentLng,
                            type: mark,
                        };
                        that.$http
                            .post("/saveUserPosition", qs.stringify(ops))
                            .then((res) => {
                                console.log(res);
                            });
                        console.log(`
				            纬度：${latitude}
				            经度：${longitude}
				          `)
                    },
                    // 失败回调
                    function(error) {
                        console.log(error);
                        clearInterval(that.realTimer);
                        if (that.hear != "") {
                            that.map.removeLayer(that.hear);
                        }
                        that.map.removeLayer(that.hear);
                        that.isSelfMotion = true;
                        that.isSliderActive = false;
                        // alert(JSON.stringify(res))
                        // console.log(res);
                        Toast("定位失败,请重新开启定位！");
                        // let errorMessage = "";
                        // switch (error.code) {
                        // 	case error.PERMISSION_DENIED:
                        // 		errorMessage = "用户拒绝了位置请求！";
                        // 		break;
                        // 	case error.POSITION_UNAVAILABLE:
                        // 		errorMessage = "位置信息不可用！";
                        // 		break;
                        // 	case error.TIMEOUT:
                        // 		errorMessage = "获取位置信息超时！";
                        // 		break;
                        // 	default:
                        // 		errorMessage = "未知错误！";
                        // }
                        // console.log(`<p>${errorMessage}</p>`)
                    },
                    // 定位选项（可选）
                    {
                        enableHighAccuracy: true, // 尽可能获取高精度结果
                        timeout: 5000, // 超时时间（毫秒）
                        maximumAge: 0, // 禁止缓存
                    }
                );
                // var that = this;
                // wx.ready(function() {
                // 	console.log(123123);
                // 	wx.getLocation({
                // 		type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                // 		success: function(res) {
                // 			console.log(res);
                // 			//39.999944,116.326955
                // 			var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // 			var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // 			//var lngLat = that.gcj02tobd09(longitude, latitude);
                // 			that.currentLat = latitude;
                // 			that.currentLng = longitude;
                // 			that.scenicAreaFn(that.currentLat, that.currentLng);
                // 			if (that.hear != "") {
                // 				that.map.removeLayer(that.hear);
                // 			}
                // 			that.hear = L.marker([that.currentLat * 1, that.currentLng * 1], {
                // 				icon: that.dingweiPng,
                // 			}).addTo(that.map);
                // 			// if(mark == 0) {
                // 			// 	var zoom = that.map.getZoom()
                // 			// 	that.map.setView(L.latLng(that.currentLat* 1,that.currentLng* 1),zoom)
                // 			// }
                // 			var qs = require("qs");
                // 			var ops = {
                // 				guideScId: that.uuid,
                // 				userid: that.userId,
                // 				lat: that.currentLat,
                // 				lng: that.currentLng,
                // 				type: mark,
                // 			};
                // 			that.$http
                // 				.post("/saveUserPosition", qs.stringify(ops))
                // 				.then((res) => {
                // 					console.log(res);
                // 				});
                // 		},
                // 		cancel: function(res) {
                // 			console.log(res);
                // 		},
                // 		fail: function(res) {
                // 			console.log(res);
                // 			clearInterval(that.realTimer);
                // 			if (that.hear != "") {
                // 				that.map.removeLayer(that.hear);
                // 			}
                // 			that.map.removeLayer(that.hear);
                // 			that.isSelfMotion = true;
                // 			that.isSliderActive = false;
                // 			// alert(JSON.stringify(res))
                // 			// console.log(res);
                // 			alert("定位失败,请重新开启定位！");
                // 		},
                // 	});
                // });
                //39.921329,116.396836
                //39.92121849,116.39665200
                // that.currentLat = 40.0017626953125;
                // that.currentLng = 116.32417724609375;
                // that.scenicAreaFn(that.currentLat, that.currentLng);
                // if(that.hear!=''){that.map.removeLayer(that.hear)}
                // that.hear = L.marker(
                // 	[that.currentLat * 1, that.currentLng * 1], {
                // 		icon: that.dingweiPng
                // 	}
                // ).addTo(that.map);
            },
            scenicAreaFn(lat, lng) {
                //判断是否自动播放
                var boundsbd = this.pointRange;
                if (
                    lat > boundsbd[0][0] &&
                    lat < boundsbd[1][0] &&
                    lng > boundsbd[0][1] &&
                    lng < boundsbd[1][1]
                ) {
                    this.isScenicArea = true;
                    this.islocation = true;
                } else {
                    this.isScenicArea = false;
                    this.islocation = false;
                }
                if (!this.isPointRangeFn) {
                    if (!this.isfadeIn) {
                        this.autoPlayModel();
                    } else {
                        this.isSelfMotion = true;
                        this.sliderMoveFn();
                    }
                    this.isPointRangeFn = true;
                } else {
                    if (this.isScenicArea) {
                        this.isSelfMotionFn(this.scenicsMarker);
                    }
                }
            },
            autoPlayModel() {
                //自动播放弹窗
                if (this.isScenicArea) {
                    //在景区内
                    this.isSelfMotion = true;
                    this.isfadeIn = true;
                    // if (this.isAndroidOrIos == "android") {
                    // 	setTimeout(() => {
                    // 		this.sliderMoveFn();
                    // 	}, 0);
                    // } else {

                    // }
                } else {
                    this.InOrOutTxt = "您不在景区内，请手动点击";
                    this.isInOrOutShow = true;
                    setTimeout(() => {
                        this.isInOrOutShow = false;
                    }, 2000);
                }
            },
            spotCancel() {
                this.isfadeIn = false;
                // clearInterval(this.realTimer);
                // this.realTimer = setInterval(() => {
                // 	this.getCurrentPos(0);
                // }, 5000);
            },
            spotTrue() {
                this.isfadeIn = false;
                this.sliderMoveFn();
            },
            sliderMoveFn() {
                if (this.subDetailsModelFlag == -1) {
                    this.subDetailsModelFlag = -1;
                } else {
                    this.subDetailsModelFlag = 1;
                }
                var auxiliarys = this.scenicsMarker;
                if (this.isScenicArea) {
                    //在景区内
                    this.interval = setInterval(() => {
                        this.getLocationFn();
                        console.log("在景区内----倒计时");
                    }, 30000);
                    if (this.isSelfMotion) {
                        this.isSelfMotion = false;
                        this.isSliderActive = true;
                        this.isSelfMotionFn(auxiliarys);
                        clearInterval(this.realTimer);
                        var qs = require("qs");
                        var ops = {
                            guideScId: this.uuid,
                            userid: this.userId,
                            lat: this.currentLat,
                            lng: this.currentLng,
                            type: this.mark,
                        };
                        this.$http
                            .post("/saveUserPosition", qs.stringify(ops))
                            .then((res) => {
                                console.log(res);
                            });
                        // this.getCurrentPos(0, 0);
                        this.realTimer = setInterval(() => {
                            this.getCurrentPos(0);
                            console.log("在景区内----倒计时");
                        }, 30000);
                    } else {
                        clearInterval(this.realTimer);
                        this.map.removeLayer(this.hear);
                        this.isSelfMotion = true;
                        this.isSliderActive = false;
                    }
                } else {
                    //不在景区内
                    this.InOrOutTxt = "您不在景区内，请手动点击";
                    this.isInOrOutShow = true;
                    setTimeout(() => {
                        this.isInOrOutShow = false;
                    }, 2000);
                }
            },
            isSelfMotionFn(auxiliarys) {
                //是否自动播放
                console.log('自动播放', this.isSliderActive)
                // for (let i in auxiliarys) {
                // 	if (auxiliarys[i].scenicsAudios == null || auxiliarys[i].scenicsAudios.lat == null) {
                // 		console.log(auxiliarys[i].viewName)
                // 	}
                // }
                // return
                if (this.isSliderActive) {
                    var lat = this.currentLat;
                    var lng = this.currentLng;
                    var index = -1;
                    var distanceArr = [];
                    var distanceEnd = [];
                    var typeState = 0;
                    var scope = 50;
                    for (var i = 0; i < auxiliarys.length; i++) {
                        var point = JSON.parse(auxiliarys[i].lat);
                        if (auxiliarys[i].scenicsAudios != null) {
                            //没有数据
                            if (auxiliarys[i].scenicsAudios.lat != null) {
                                //有矩形范围的时候
                                var latAndLng = JSON.parse(auxiliarys[i].scenicsAudios.lat);
                                var minLat = latAndLng[0][0];
                                var maxLat = latAndLng[0][0];
                                var minLng = latAndLng[0][1];
                                var maxLng = latAndLng[0][1];
                                for (var j = 0; j < latAndLng.length; j++) {
                                    if (maxLat <= latAndLng[j][0]) {
                                        maxLat = latAndLng[j][0];
                                    }
                                    if (latAndLng[j][0] <= minLat) {
                                        minLat = latAndLng[j][0];
                                    }
                                    if (maxLng <= latAndLng[j][1]) {
                                        maxLng = latAndLng[j][1];
                                    }
                                    if (latAndLng[j][1] <= minLng) {
                                        minLng = latAndLng[j][1];
                                    }
                                }
                                // console.log(
                                // 	lat >= minLat,
                                // 	lat <= maxLat,
                                // 	lng >= minLng,
                                // 	lng <= maxLng,
                                // );
                                if (
                                    lat >= minLat &&
                                    lat <= maxLat &&
                                    lng >= minLng &&
                                    lng <= maxLng
                                ) {
                                    if (this.myAudio.paused) {
                                        typeState = 0;
                                        index = i;
                                    }
                                }
                            } else if (auxiliarys[i].scenicsAudios.lat == null) {
                                //有圆形范围的时候
                                var radius = auxiliarys[i].scenicsAudios.radius;
                                radius = radius == null ? this.defaultRadius : radius;
                                var latlng = L.latLng(point);
                                var distance = parseInt(latlng.distanceTo(L.latLng(lat, lng)));
                                distanceArr.push({
                                    distance: distance,
                                    index: i
                                });
                                // console.log('排行', distanceArr)
                                if (distance < radius) {
                                    distanceEnd.push(distance);
                                    distanceEnd = distanceEnd.sort(function(a, b) {
                                        return a - b;
                                    });

                                    for (let i = 0; i < distanceArr.length; i++) {
                                        if (distanceArr[i].distance == distanceEnd[0]) {
                                            if (this.myAudio.paused) {
                                                typeState = 1;
                                                scope = Math.floor(distanceEnd[0] / 2);
                                                index = distanceArr[i].index;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    console.log('播放音频的下标', index);
                    if (index != -1 && this.scenicIconFlag && this.myAudio.paused) {
                        //var index = this.currentPlayIndex;
                        const {
                            viewName,
                            enViewName,
                            scenicsAudios,
                            lat
                        } =
                        auxiliarys[index];
                        const viewNameCE = this.isChEnActive ? enViewName : viewName;
                        var myIcon2 = L.divIcon({
                            html: `<text class='div-icon'>${viewNameCE}</text>`,
                            className: "my-div-icon",
                        });
                        const audioUrlCE = this.isChEnActive ?
                            scenicsAudios.enAudioUrl :
                            scenicsAudios.audioUrl;
                        if (this.myAudioSrc != audioUrlCE) {
                            this.timeTxt = "";
                            this.myAudioSrc = audioUrlCE;
                            this.myAudio.src = this.myAudioSrc;
                            this.myAudio.playbackRate = this.multipleIndexTxt;
                            var lng = JSON.parse(lat);
                            this.map.setView(L.latLng(lng[0], lng[1]), this.maxZoomlevel);
                            this.isCurrentPlay = true;
                            for (var i = 0; i < this.markersArr.length; i++) {
                                const {
                                    viewName,
                                    enViewName
                                } = auxiliarys[i];
                                const viewNameCE = this.isChEnActive ? enViewName : viewName;
                                var myIcon1 = L.divIcon({
                                    html: `<text class='div-icon'>${viewNameCE}</text>`,
                                    className: "my-div-icon",
                                });
                                this.markersArr[i].setIcon(this.scenicIcon);
                                // this.markersTxtArr[i].setIcon(myIcon1);
                            }
                            this.markersArr[index].setIcon(this.myIconPause);
                            // this.markersTxtArr[index].setIcon(myIcon2);
                            this.markers.refreshClusters();
                            this.markerDivs.refreshClusters();
                            this.markerDivsTag.refreshClusters();
                            this.currentOrNextClick(auxiliarys, index);

                            let obj = [{
                                img: this.scenicImgurl,
                                relationName: auxiliarys[index].viewName,
                                name: this.title,
                                uuid: this.uuid,
                                userId: this.userId,
                                type: 2,
                                relationId: auxiliarys[index].viewId,
                                isAutoplay: 1,
                            }, ];
                            this.$http({
                                url: "https://www.tmm6.cn/travelwalkman/know/addRecord",
                                method: "post",
                                data: obj,
                            }).then((res) => {
                                console.log(res);
                            });
                        }
                        this.isSelfMotion = false;
                    }
                }
            },
            cutSetMarkerSheshi(auxiliarys) {
                //console.log(auxiliarys)
                this.markersSheshi = L.markerClusterGroup({
                    maxClusterRadius: 30,
                    spiderfyOnMaxZoom: false,
                    disableClusteringAtZoom: this.maxZoomlevel,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    removeOutsideVisibleBounds: false,
                    iconCreateFunction(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        return L.icon({
                            iconUrl: markers[0].options.icon.options.iconUrl,
                            iconSize: [15, 15],
                            className: "zIndexClass",
                        });
                    },
                });
                for (var i = 0; i < auxiliarys.length; i++) {
                    const {
                        lat,
                        enViewName,
                        viewName,
                        viewIcon
                    } = auxiliarys[i];
                    var latLng = JSON.parse(lat);

                    var scenicIcon = L.icon({
                        iconUrl: viewIcon,
                        iconSize: [15, 15],
                        zIndex: -1,
                        className: "zIndexClass",
                    });
                    var m = L.marker([latLng[0], latLng[1]], {
                        icon: scenicIcon,
                        title: viewName,
                    });
                    this.markersSheshi.addLayer(m);
                }
                this.map.addLayer(this.markersSheshi);
            },
            cutSetMarkerTag(auxiliarys, mark, className) {
                console.log('asd', auxiliarys, mark)
                var that = this;
                this.markersTag = L.markerClusterGroup({
                    maxClusterRadius: 30,
                    spiderfyOnMaxZoom: false,
                    disableClusteringAtZoom: this.maxZoomlevel,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    removeOutsideVisibleBounds: false,
                    iconCreateFunction: function(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        if (mark == "tag") {
                            return L.icon({
                                iconUrl: that.viewIconTagImg,
                                iconSize: [20, 20],
                                tag: markers[0].options.tag,
                                index: markers[0].options.index,
                            });
                        } else {
                            return L.icon({
                                iconUrl: markers[0].options.icon.options.iconUrl,
                                iconSize: [15, 15],
                                tag: markers[0].options.tag,
                                index: markers[0].options.index,
                            });
                        }
                    },
                });
                this.markerDivsTag = L.markerClusterGroup({
                    maxClusterRadius: 30,
                    spiderfyOnMaxZoom: false,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    removeOutsideVisibleBounds: false,
                    iconCreateFunction: function(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        var titles = "";
                        for (var i = 0; i < markers.length; i++) {
                            titles +=
                                markers[i].options.title + (i == markers.length - 1 ? "" : "、");
                        }
                        titles =
                            titles.length > 30 ? titles.substring(0, 29) + "..." : titles;
                        let html = "";
                        if (mark == "tag") {
                            html = "<text class='div-icontag'>" + titles + "</text>";
                        } else {
                            html = "<text></text>";
                        }
                        return L.divIcon({
                            html: html,
                            className: "my-div-iconmg",
                            index: markers[0].options.index,
                        });
                    },
                });
                for (var i = 0; i < auxiliarys.length; i++) {
                    const {
                        lat,
                        enViewName,
                        viewName,
                        viewIcon,
                        showType
                    } = auxiliarys[i];
                    var latLng = JSON.parse(lat);
                    var tag = showType;
                    var viewNameCE = this.isChEnActive ? enViewName || "" : viewName;
                    var viewNameSwitch =
                        viewNameCE.length > 30 ?
                        viewNameCE.substring(0, 29) + "..." :
                        viewNameCE;
                    // console.log(viewNameSwitch);
                    if (mark == "tag") {
                        var myIcon1 = L.divIcon({
                            html: "<text class='div-icontag'>" + viewNameSwitch + "</text>",
                            className: "my-div-iconmg",
                        });
                        var m = L.marker([latLng[0], latLng[1]], {
                            icon: this.dingweiPng,
                            title: viewNameSwitch,
                            index: i,
                            // tag: tag,
                            zIndexOffset: 1000,
                        });
                    } else {
                        var myIcon1 = L.divIcon({
                            html: "<text></text>",
                            className: className[0],
                        });
                        var scenicIcon = L.icon({
                            iconUrl: auxiliarys[i].viewIcon,
                            iconSize: [15, 15],
                        });
                        var m = L.marker([latLng[0], latLng[1]], {
                            icon: scenicIcon,
                            title: viewNameSwitch,
                            index: i,
                            tag: tag,
                            zIndexOffset: 1000,
                        });
                    }

                    var m2 = L.marker([latLng[0], latLng[1]], {
                        icon: myIcon1,
                        title: viewNameSwitch,
                        index: i,
                        tag: tag,
                        zIndexOffset: -100,
                    });
                    //this.markersTag.addLayer(m);
                    this.markerDivsTag.addLayer(m2);
                }
                //this.map.addLayer(this.markersTag);
                this.map.addLayer(this.markerDivsTag); //上边的文字
                //this.isloading = this.$store.state.isLoading = false;
            },
            getBack() {
                uni.postMessage({
                    data: {
                        action: 'getback'
                    }
                });
            },
            cutSetMarkerSc(auxiliarys, viewIcon) {
                console.log(auxiliarys)
                var that = this;
                this.num = -1;
                this.num2 = -1;
                this.markers = L.markerClusterGroup({
                    maxClusterRadius: 30,
                    spiderfyOnMaxZoom: false,
                    disableClusteringAtZoom: this.maxZoomlevel,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    removeOutsideVisibleBounds: false,
                    iconCreateFunction: function(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        that.num = -1;
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].options.index == that.currentPlayIndex) {
                                that.num = i;
                            }
                        }
                        if (that.num != -1 && that.scenicIconFlag) {
                            var iconUrl = markers[that.num].options.icon.options.iconUrl;
                            return L.icon({
                                iconUrl: iconUrl,
                                iconSize: [30, 30],
                                index: markers[that.num].options.index,
                            });
                        } else {
                            return L.icon({
                                iconUrl: markers[0].options.icon.options.iconUrl,
                                iconSize: [60, 60],
                                tag: markers[0].options.tag,
                                index: markers[0].options.index,
                            });
                        }
                    },
                });
                this.markerDivs = L.markerClusterGroup({
                    maxClusterRadius: 30,
                    spiderfyOnMaxZoom: false,
                    disableClusteringAtZoom: this.maxZoomlevel,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    removeOutsideVisibleBounds: false,
                    iconCreateFunction: function(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        var titles = "";
                        that.num2 = -1;
                        for (var i = 0; i < markers.length; i++) {
                            titles +=
                                markers[i].options.title + (i == markers.length - 1 ? "" : "、");
                            if (markers[i].options.index == that.currentPlayIndex) {
                                that.num2 = i;
                            }
                        }
                        if (that.num2 != -1 && that.scenicIconFlag) {
                            titles =
                                titles.length > 30 ? titles.substring(0, 29) + "..." : titles;
                            return L.divIcon({
                                html: "<text class='div-icon'>" + titles + "</text>",
                                className: "my-div-icon",
                                index: markers[that.num2].options.index,
                            });
                        } else {
                            titles =
                                titles.length > 30 ? titles.substring(0, 29) + "..." : titles;
                            return L.divIcon({
                                html: "<text class='div-icon'>" + titles + "</text>",
                                className: "my-div-icon",
                                index: markers[0].options.index,
                            });
                        }
                    },
                });

                for (var i = 0; i < auxiliarys.length; i++) {
                    const {
                        lat,
                        enViewName,
                        viewName,
                        viewIcon,
                        showType,
                        must,
                        viewType,
                        jumpType
                    } =
                    auxiliarys[i];
                    console.log('asdasd', auxiliarys)
                    if (jumpType != 'li' && jumpType != 're') {
                        this.scenicIcon = L.icon({
                            iconUrl: viewIcon,
                            iconSize: [70, 70],
                        });
                    }

                    if (jumpType == 're') {
                        this.scenicIconre = L.icon({
                            iconUrl: this.reTagImg,
                            iconSize: [30, 30],
                        });
                    }
                    if (jumpType == 'li') {
                        this.scenicIconreli = L.icon({
                            iconUrl: this.viewIconMore,
                            iconSize: [30, 30],
                        });
                    }
                    var latLng = JSON.parse(lat);
                    var tag = showType;
                    var viewNameCE = this.isChEnActive ? enViewName || "" : viewName;
                    var viewNameSwitch =
                        viewNameCE.length > 30 ?
                        viewNameCE.substring(0, 29) + "..." :
                        viewNameCE;
                    if (must === 1) {
                        var myIcon1 = L.divIcon({
                            html: `<text class='div-icon'>${viewNameSwitch}<img class='acrive-mast' src='https://www.tmm6.cn/travelwalkman/resources/hot-map.png'/></text>`,
                            className: "my-div-icon",
                            mark: "sc",
                        });
                    } else {
                        var myIcon1 = L.divIcon({
                            html: `<text class='div-icon'>${viewNameSwitch}</text>`,
                            className: "my-div-icon",
                            mark: "sc",
                        });
                    }
                    var myIcon2 = L.divIcon({
                        html: "<text class='div-icon'>" + viewNameSwitch + "</text>",
                        className: "my-div-icon",
                    });
                    if (i == this.currentPlayIndex && this.scenicIconFlag) {
                        //播放中
                        if (this.isCurrentPlay) {
                            var m = L.marker([latLng[0], latLng[1]], {
                                icon: this.myIconPause,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: 1000,
                            });
                        } else {
                            var m = L.marker([latLng[0], latLng[1]], {
                                icon: this.myIconGif,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: 1000,
                            });
                        }
                        var m2 = L.marker([latLng[0], latLng[1]], {
                            icon: myIcon2,
                            title: viewNameSwitch,
                            index: i,
                            zIndexOffset: -100,
                        });
                    } else {
                        if (jumpType == 're') {
                            //未播放中
                            var m = L.marker([latLng[0], latLng[1]], {
                                icon: this.scenicIconre,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: 1000,
                            });
                            var m2 = L.marker([latLng[0], latLng[1]], {
                                icon: myIcon1,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: -100,
                            });
                        } else if (jumpType == 'li') {
                            //未播放中
                            var m = L.marker([latLng[0], latLng[1]], {
                                icon: this.scenicIconreli,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: 1000,
                            });
                            var m2 = L.marker([latLng[0], latLng[1]], {
                                icon: myIcon1,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: -100,
                            });
                        } else {
                            //未播放中
                            var m = L.marker([latLng[0], latLng[1]], {
                                icon: this.scenicIcon,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: 1000,
                            });
                            var m2 = L.marker([latLng[0], latLng[1]], {
                                icon: myIcon1,
                                title: viewNameSwitch,
                                index: i,
                                tag: tag,
                                zIndexOffset: -100,
                            });
                        }
                        // var m3 = L.marker([latLng[0], latLng[1]], {
                        //   icon: myIcon3,
                        //   title: viewNameSwitch,
                        //   index: i,
                        //   tag: tag,
                        //   zIndexOffset: -100,
                        // });
                    }
                    this.markers.addLayer(m);
                    this.markerDivs.addLayer(m2);
                    this.markersArr.push(m);
                    // this.markersArr.push(m3);
                    this.markersTxtArr.push(m2);
                }
                //console.log(that.markers)
                //console.log(this.markerDivs)
                this.map.addLayer(this.markers);
                this.map.addLayer(this.markerDivs); //上边的文字
                this.map.on("zoomend", function() {
                    that.num = -1;
                    that.num2 = -1;
                    that.markers.refreshClusters();
                    that.markerDivs.refreshClusters();
                });
                // const that = this;
                this.markers.on("click", function(e) {
                    console.log(e)
                    console.log('clusterclick', auxiliarys[e.layer.options.index])
                    if (auxiliarys[e.layer.options.index].jumpType == 're') {
                        uni.postMessage({
                            data: {
                                action: 'skip',
                                data: auxiliarys[e.layer.options.index]
                            }
                        });
                        return
                    }
                    if (auxiliarys[e.layer.options.index].jumpType == 'li') {
                        that.jumpscience(auxiliarys[e.layer.options.index].viewId)
                        return
                    }
                    console.log('当前列表播放状态', that.isPlaying)
                    if (that.isPlaying) {
                        that.$refs.audio.pause();
                        that.isPlaying = false;
                        that.progressBarIndex = -1
                    }
                    //marker 点击事件
                    if (that.scenicIconFlag) {
                        var index = e.layer.options.index; //获取到当前marker点的下标
                        that.flag = false;
                        console.log(e);
                        that.currentOrNextClick(auxiliarys, index); //marker点执行函数
                        let obj = [{
                            img: that.scenicImgurl,
                            relationName: auxiliarys[index].viewName,
                            name: that.title,
                            uuid: that.uuid,
                            userId: that.userId,
                            type: 2,
                            relationId: auxiliarys[index].viewId,
                            isAutoplay: 0,
                        }, ];
                        that
                            .$http({
                                url: "https://www.tmm6.cn/travelwalkman/know/addRecord",
                                method: "post",
                                data: obj,
                            })
                            .then((res) => {
                                console.log(res);
                            });
                    }
                });
                this.markers.on("clusterclick", function(e) {
                    console.log(e.layer._iconObj.options.index)
                    if (that.scenicIconFlag) {
                        var index = e.layer._iconObj.options.index;
                        that.currentOrNextClick(auxiliarys, index);
                    }
                });
                // that.markerDivs.on('click', function(e) { //marker 点击事件
                // 	console.log('marker点')
                // 	if (that.scenicIconFlag) {
                // 		var index = e.layer.options.index
                // 		that.currentOrNextClick(auxiliarys, index)
                // 	}
                // });
                // that.markerDivs.on('clusterclick', function(e) {
                // 	console.log('marker点')
                // 	if (that.scenicIconFlag) {
                // 		var index = e.layer._iconObj.options.index;
                // 		that.currentOrNextClick(auxiliarys, index)
                // 	}
                // });
            },
            currentOrNextClick(auxiliarys, index, isToast = true) {
                console.log('正在播放的音乐下标', index, this.currentPlayIndex);

                var currentPlayIndex = this.currentPlayIndex;
                this.prevcurrentIndex = this.currentPlayIndex;
                const {
                    enViewName,
                    viewName,
                    viewShowUrl,
                    scenicsAudios
                } = auxiliarys[index];
                var viewNameCE = this.isChEnActive ? enViewName : viewName;
                var myIcon2 = L.divIcon({
                    html: `<text class='div-icon'>${viewNameCE}</text>`,
                    className: "my-div-icon",
                });

                if (this.subDetailsModelFlag == -1) {
                    this.subDetailsModelFlag = -1;
                } else {
                    this.subDetailsModelFlag = 1;
                }

                this.isPlayIndex = index; // 保存当前播放的 index 值
                if (isToast) {
                    this.isFooterShow = true; // 底部是否显示
                }

                if (currentPlayIndex == index) {
                    // 点击的是当前播放中的 marker
                    if (!this.isCurrentPlay) {
                        // 播放中
                        this.playOrpause = 0; // 底部按钮是播放中还是暂停中
                        this.isCurrentPlay = true; // 保存当前播放的状态
                        if (this.scenicIconFlag) {
                            this.markersArr[index].setIcon(this.myIconPause); // 设置 marker 图标为暂停按钮
                            this.markers.refreshClusters(); // 刷新 marker 点
                            this.markerDivs.refreshClusters(); // 刷新 marker 点下文字点
                        }
                        if (this.currentTime == 0) {
                            const audioUrlCE = this.isChEnActive ? scenicsAudios.enAudioUrl : scenicsAudios.audioUrl;
                            this.myAudio.src = audioUrlCE; // 播放当前语音
                            this.myAudioSrc = audioUrlCE;
                        }
                        this.myAudio.pause();
                    } else {
                        // 暂停中
                        this.playOrpause = 2; // 底部按钮是播放中还是暂停中
                        this.isCurrentPlay = false; // 保存当前播放的状态
                        if (this.scenicIconFlag) {
                            this.markersArr[index].setIcon(this.myIconGif); // 设置 marker 图标为播放按钮
                            this.markers.refreshClusters(); // 刷新 marker 点
                            this.markerDivs.refreshClusters(); // 刷新 marker 点下文字点
                        }
                        if (this.currentTime == 0) {
                            const audioUrlCE = this.isChEnActive ? scenicsAudios.enAudioUrl : scenicsAudios.audioUrl;
                            this.myAudio.src = audioUrlCE; // 播放当前语音
                            this.myAudioSrc = audioUrlCE;
                        }
                        this.myAudio.play();
                        this.myAudio.method = "muted";
                    }
                } else {
                    // 点击下一个 marker
                    this.currentPlayingTxt = ""; // 弹图景点名称设置为空
                    this.currentImg = ""; // 弹图设置为空

                    if (currentPlayIndex != -1) {
                        // marker 点不是第一次点击的时候
                        var myIcon1 = L.divIcon({
                            html: `<text class='div-icon'>${viewNameCE}</text>`,
                            className: "my-div-icon",
                        });
                        if (this.scenicIconFlag) {
                            this.markersArr[currentPlayIndex].setIcon(this.scenicIcon);
                            this.markers.refreshClusters();
                            this.markerDivs.refreshClusters();
                        }
                    }

                    this.currentPlayIndex = index; // 保存当前播放的状态
                    this.currentImg = viewShowUrl; // 保存弹出图片的 img
                    this.currentPlayingTxt = "正在播放" + viewNameCE; // 当前弹图的景点名称
                    this.isCurrentPlaying = 1;

                    // 5 秒后消失
                    setTimeout(() => {
                        this.currentPlayingTxt = "";
                        this.isCurrentPlaying = 2;
                        setTimeout(() => {
                            this.currentImg = "";
                        }, 500);
                    }, 5000);

                    const audioUrlCE = this.isChEnActive ? scenicsAudios.enAudioUrl : scenicsAudios.audioUrl;
                    this.myAudio.src = audioUrlCE; // 播放当前语音
                    this.myAudioSrc = audioUrlCE;

                    if (this.scenicIconFlag) {
                        this.markersArr[index].setIcon(this.myIconGif);
                    }

                    if (this.prevcurrentIndex != -1) {
                        this.timeByScenidsMaker(this.prevcurrentIndex, this.currentDuration);
                    }

                    this.markers.refreshClusters();
                    this.markerDivs.refreshClusters();
                    this.audioAutoPlay("music1");

                    // 确保音频播放
                    this.myAudio.play().catch(error => {
                        console.error("音频播放失败:", error);
                    });
                    this.myAudio.method = "muted";
                    this.isCurrentPlay = false; // 保存当前播放的状态
                }
            },
            scenicActiveTabEnd(index) {
                //点击头部tab
                this.currentIconIndex = index;
                this.scenicIconFlag = true;
                this.ismodelActive = true;
                var scenicsMarker = this.scenicsMarker;
                clearTimeout(this.timer);
                this.myIcon = L.icon({
                    iconUrl: this.currentScenicsImg,
                    iconSize: [30, 30],
                });
                this.removeLayer();
                this.markersArr = [];
                this.markersTxtArr = [];
                let auxiliarysTag = [],
                    auxiliarysSc = [];
                for (let i = 0; i < scenicsMarker.length; i++) {
                    if (scenicsMarker[i].showType == "sc") {
                        auxiliarysSc.push(scenicsMarker[i]);
                    } else {
                        auxiliarysTag.push(scenicsMarker[i]);
                    }
                }
                var className = ["my-div-iconTag", "div-iconTag"];
                this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
                if (this.isPlayIndex != -1) {
                    var lng = JSON.parse(this.scenicsMarker[this.isPlayIndex].lat);
                    this.map.setView(L.latLng(lng[0], lng[1]), this.maxZoomlevel);
                } else {
                    this.map.setZoom(this.currentZoom);
                }
            },
            //点击缩放地图
            handleMaxTouchStart() {
                console.log('按下')
                //按下
                if (this.subDetailsModelFlag == -1) {
                    this.subDetailsModelFlag = -1;
                } else {
                    this.subDetailsModelFlag = 1;
                }
                var maxZoomlevel = this.maxZoomlevel * 1; //最大缩放级别
                var currentZoom = this.map.getZoom();
                if (currentZoom < this.maxZoomlevel) {
                    this.isMaxActive = true;
                }
            },
            handleMaxTouchEnd() {
                //抬起
                var maxZoomlevel = this.maxZoomlevel * 1; //最大缩放级别
                var currentZoom = this.map.getZoom();
                if (currentZoom >= this.maxZoomlevel) {
                    //已经到最大缩放级别
                    this.isMinOrMaxHint = true;
                    this.isMinOrMaxHintTxt = "已到最大缩放级别";
                    setTimeout(() => {
                        this.isMinOrMaxHint = false;
                        this.isMinOrMaxHintTxt = "";
                    }, 2000);
                } else {
                    currentZoom++;
                    this.map.setZoom(currentZoom);
                }
                this.isMaxActive = false;
            },
            handleMinTouchStart() {
                //按下
                if (this.subDetailsModelFlag == -1) {
                    this.subDetailsModelFlag = -1;
                } else {
                    this.subDetailsModelFlag = 1;
                }
                var minZoomlevel = this.minZoomlevel * 1; //最大缩放级别
                var currentZoom = this.map.getZoom();
                if (currentZoom > this.minZoomlevel) {
                    this.isMinActive = true;
                }
            },
            handleMinTouchEnd() {
                //抬起
                var minZoomlevel = this.minZoomlevel * 1; //最大缩放级别
                var currentZoom = this.map.getZoom();
                if (currentZoom <= this.minZoomlevel) {
                    //已经到最大缩放级别
                    this.isMinOrMaxHint = true;
                    this.isMinOrMaxHintTxt = "已到最小缩放级别";
                    setTimeout(() => {
                        this.isMinOrMaxHint = false;
                        this.isMinOrMaxHintTxt = "";
                    }, 2000);
                } else {
                    currentZoom--;
                    this.map.setZoom(currentZoom);
                }
                this.isMinActive = false;
            },
            recommendedLine() {
                var qs = require("qs");
                var ops = {
                    uuid: this.uuid,
                };
                this.$http.post("/guideScenicsLines", qs.stringify(ops)).then((res) => {
                    if (res.state == "200") {
                        this.linetracksArr = res.list;
                        this.linetracksLen = this.linetracksArr.length;
                        this.currentLineIndex = this.linetracksArr.length;
                    }
                });
            },
            recommendedLineTabEnd(index) {
                this.tableIndex = 1;
                this.removeLayer();
                clearTimeout(this.timer);
                this.lineSetTxtMarker();
                this.map.setZoom(this.currentZoom);
                var linetracksArr = this.linetracksArr;
                var lineArrLen = this.linetracksArr.length;
                var that = this;
                this.lineArrLen = lineArrLen;
                this.currentIconIndex = index;
                this.scenicIconFlag = false;
                this.ismodelActive = true;
                var trackRoute = [];
                if (lineArrLen != 0) {
                    this.map.removeLayer(this.polyline);
                    var detailArr = []; //所有值
                    this.isMinOrMaxHint = true;
                    this.isMinOrMaxHintTxt =
                        this.linetracksArr[this.currentLineIndex - 1].lineName;
                    setTimeout(() => {
                        this.isMinOrMaxHint = false;
                        this.isMinOrMaxHintTxt = "";
                    }, 2000);
                    this.currentLineIndex--;
                    if (this.currentLineIndex <= 0) {
                        this.currentLineIndex = lineArrLen;
                    }
                    //线路
                    var detail = eval(
                        this.linetracksArr[this.currentLineIndex - 1].detailtx
                    );
                    var num = 0;

                    var lineImg = linetracksArr[this.currentLineIndex - 1].icon;
                    var myIcon = L.icon({
                        iconUrl: lineImg,
                        iconSize: [60, 60],
                        className: "line-img",
                    });
                    var i = 0;
                    this.timer = setTimeout(function() {
                        resetMkPoint(0);
                    }, 300);

                    function resetMkPoint(i) {
                        if (detail[i] != undefined) {
                            that.myLayerGroup3.clearLayers();
                            var pos = detail[i].pos.split(",");
                            var arr = [];
                            for (var j = 0; j < pos.length; j++) {
                                arr.push(Number(pos[j]));
                            }
                            detailArr.push(arr);

                            if (detail[i].mark == 1) {
                                num++;
                                var marker1 = L.marker([arr[0], arr[1]], {
                                    icon: L.icon({
                                        iconUrl: require("../../static/img/red-yuan.png"),
                                        iconSize: [20, 20],
                                    }),
                                    zIndexOffset: 1000,
                                });
                                var marker2 = L.marker([arr[0], arr[1]], {
                                    icon: L.divIcon({
                                        html: "<p style='color:#fff;text-align:center;'>" + num +
                                            "</p>",
                                        className: "my-num",
                                    }),
                                    zIndexOffset: 1000,
                                });
                                that.myLayerGroup1.addLayer(marker1);
                                that.map.addLayer(that.myLayerGroup1);
                                that.myLayerGroup2.addLayer(marker2);
                                that.map.addLayer(that.myLayerGroup2);
                            }
                            var marker3 = L.marker([arr[0], arr[1]], {
                                icon: myIcon,
                                zIndexOffset: 1000,
                            });
                            that.myLayerGroup3.addLayer(marker3);
                            that.map.addLayer(that.myLayerGroup3);
                            var p = detailArr.slice(i - 1, i + 1);
                            if (p.length > 1) {
                                var polyline = L.polyline(detailArr, {
                                    color: "red",
                                    weight: 6,
                                    opacity: 1,
                                }).addTo(that.map);
                                // var decorator = L.polylineDecorator(polyline, {
                                // 	patterns: [
                                // 		{offset: 25, repeat: 50, symbol: L.Symbol.arrowHead({pixelSize: 10, pathOptions: {fillOpacity: 1, weight:0,color:'#fff'}})}
                                // 	]
                                // }).addTo(that.map);
                                that.myLayerGroup4.addLayer(polyline);
                                //that.myLayerGroup4.addLayer(decorator);
                                that.map.addLayer(that.myLayerGroup4);
                            }
                            that.timer = setTimeout(function() {
                                i++;
                                resetMkPoint(i);
                            }, 300);
                        }
                    }
                    //}
                } else {
                    this.isMinOrMaxHint = true;
                    this.isMinOrMaxHintTxt = "暂无推荐路线";
                    setTimeout(() => {
                        this.isMinOrMaxHint = false;
                        this.isMinOrMaxHintTxt = "";
                    }, 2000);
                }
            },
            lineSetTxtMarker() {
                var that = this;
                //var auxiliarys = this.scenicsMarker.filter;
                this.myLayerGroup = L.markerClusterGroup({
                    maxClusterRadius: 60,
                    spiderfyOnMaxZoom: false,
                    showCoverageOnHover: false,
                    zoomToBoundsOnClick: false,
                    iconCreateFunction: function(cluster) {
                        var markers = cluster.getAllChildMarkers();
                        var options = markers[0].options.icon.options.title;
                        var title = options.length > 30 ? options.substring(0, 29) : options;
                        return L.divIcon({
                            html: "<text class='div-icon'>" + title + "</text>",
                            className: "my-div-icon",
                        });
                    },
                });
                const auxiliarys = this.scenicsMarker.filter((item) => {
                    if (this.isChEnActive) {
                        return item.showType == "sc" && item.enViewName != null;
                    } else {
                        return item.showType == "sc";
                    }
                });
                for (var i = 0; i < auxiliarys.length; i++) {
                    const {
                        lat,
                        enViewName,
                        viewName
                    } = auxiliarys[i];
                    var latLng = JSON.parse(lat);
                    var viewNameCE = this.isChEnActive ? enViewName : viewName;
                    var viewNameSwitch =
                        viewNameCE.length > 30 ?
                        viewNameCE.substring(0, 29) + "..." :
                        viewNameCE;
                    var m = L.marker([latLng[0], latLng[1]], {
                        icon: L.divIcon({
                            html: "<text class='div-icon'>" + viewNameSwitch + "</text>",
                            className: "my-div-icon",
                            title: viewNameSwitch,
                        }),
                    });
                    that.myLayerGroup.addLayer(m);
                }
                that.map.addLayer(that.myLayerGroup);
            },
            navListsModelTab() {
                this.isVoiceListsShow = false;
            },
            voiceListsShowEnd(index) {
                //抬起
                this.ismodelActive = true;
                this.currentIconIndex = index;
                this.isVoiceListsShow = true;
                this.scenicIconFlag = true;
                this.removeLayer();
                clearTimeout(this.timer);
                var scenicsMarker = this.scenicsMarker;
                this.myIcon = L.icon({
                    iconUrl: this.currentScenicsImg,
                    iconSize: [30, 30],
                });
                this.removeLayer();
                this.markersArr = [];
                this.markersTxtArr = [];
                let auxiliarysTag = [],
                    auxiliarysSc = [];
                for (let i = 0; i < scenicsMarker.length; i++) {
                    if (scenicsMarker[i].showType == "sc") {
                        auxiliarysSc.push(scenicsMarker[i]);
                    } else {
                        auxiliarysTag.push(scenicsMarker[i]);
                    }
                }
                var className = ["my-div-iconTag", "div-iconTag"];
                this.cutSetMarkerTag(auxiliarysTag, "tag", className); //设置marker点
                this.cutSetMarkerSc(auxiliarysSc, this.viewIcon); //设置marker点
                if (this.isPlayIndex != -1) {
                    var lng = JSON.parse(this.scenicsMarker[this.isPlayIndex].lat);
                    this.map.setView(L.latLng(lng[0], lng[1]), this.maxZoomlevel);
                } else {
                    this.map.setZoom(this.currentZoom);
                }
                if (this.isPlayIndex != -1) {
                    var lng = JSON.parse(this.scenicsMarker[this.isPlayIndex].lat);
                    this.map.setView(L.latLng(lng[0], lng[1]), this.maxZoomlevel);
                } else {
                    this.map.setZoom(this.currentZoom);
                }
            },
            voiceListsTab(index) {
                var scenicsMarker = this.scenicsMarker;
                const {
                    lat
                } = scenicsMarker[index];
                this.minDivLeft = "0px";
                if (this.scenicIconFlag) {
                    var lng = JSON.parse(lat);
                    this.map.setView(L.latLng(lng[0], lng[1]), this.maxZoomlevel);
                }
                this.currentOrNextClick(scenicsMarker, index);
            },
            playOrpauseClick() {
                //点击底部播放按
                if (this.isPlaying) {
                    this.$refs.audio.pause();
                    this.isPlaying = false;
                    this.progressBarIndex = -1
                }
                if (this.currentPlayIndex != -1) {
                    //在景区内
                    this.currentOrNextClick(this.scenicsMarker, this.currentPlayIndex);
                } else {
                    //不在景区内
                    this.InOrOutTxt = "请您选择播放的景点";
                    this.isInOrOutShow = true;
                    setTimeout(() => {
                        this.isInOrOutShow = false;
                    }, 2000);
                }
            },
            doStoping($event) {
                //阻止事件冒泡
            },
            moveDivStart() {
                //移动滑块
                this.ifBool = true;
            },
            moveDivMove(e) {
                var lineDiv_paddingTop =
                    (this.voiceListsPlay_width - this.lineDiv_width) / 4;
                if (this.ifBool) {
                    var x = e.touches[0].pageX || e.touches[0].clientX; //鼠标横坐标var x
                    var minDiv_left = x - lineDiv_paddingTop; //小方块相对于父元素（长线条）的left值
                    if (minDiv_left >= this.lineDiv_width) {
                        minDiv_left = this.lineDiv_width;
                    }
                    if (minDiv_left < 0) {
                        minDiv_left = 0;
                    }
                    //设置拖动后小方块的left值
                    this.minDivLeft = minDiv_left + "px";
                    this.borderYellow = minDiv_left + "px";
                    if (this.allDuration != 0) {
                        this.myAudio.currentTime =
                            (minDiv_left * this.allDuration) / this.lineDiv_width;
                    }
                }
            },
            moveDivEnd() {
                this.ifBool = false;
            },
            monitorAudioPlay() {
                var that = this;
                this.myAudio.addEventListener("canplay", function() {
                    that.allDuration = that.myAudio.duration; //获取音频总时长
                });
                this.myAudio.addEventListener(
                    "waiting",
                    function() {
                        that.isloading = that.$store.state.isLoading = true;
                        that.loadingTxt = "音频加载中...";
                        that.loadingVoice = true;
                    },
                    false
                );
                this.myAudio.addEventListener(
                    "play",
                    function() {
                        console.log("play");
                        that.isPlayOrpause = false;
                        that.playOrpause = 2;
                        clearInterval(that.awardTimer);
                    },
                    false
                );
                this.myAudio.addEventListener(
                    "pause",
                    function() {
                        console.log("pause");
                        var currentPlayIndex = that.currentPlayIndex;
                        that.isCurrentPlay = true;
                        if (that.scenicIconFlag) {
                            that.markersArr[currentPlayIndex].setIcon(that.myIconPause);
                            that.markers.refreshClusters();
                        }
                        that.isPlayOrpause = true;
                        that.playOrpause = 0;
                        that.timeByScenidsMaker(that.currentPlayIndex, that.currentDuration);
                    },
                    false
                );
                this.myAudio.addEventListener(
                    "ended",
                    function() {
                        console.log("ended");
                        var currentPlayIndex = that.currentPlayIndex;
                        that.isCurrentPlay = true;
                        if (that.scenicIconFlag) {
                            that.markersArr[currentPlayIndex].setIcon(that.myIconPause);
                            that.markers.refreshClusters();
                        }
                        that.isPlayOrpause = true;
                        that.playOrpause = 0;
                        that.isDisplayR = "none";
                        that.circle = "rect(0, 50px, 50px, 25px)";
                        that.minDivLeft = "0px";
                        that.currentPlayTime(that.allDuration);
                        that.timeByScenidsMaker(that.currentPlayIndex, that.currentDuration);
                    },
                    false
                );
                this.myAudio.addEventListener(
                    "timeupdate",
                    function() {
                        that.allDuration = that.myAudio.duration;
                        that.currentTime = that.myAudio.currentTime;
                        that.currentDuration = Math.ceil(that.myAudio.currentTime);
                        //   console.log(that.allDuration, "1");
                        //   console.log(that.currentTime, "2");
                        //   console.log(that.currentDuration, "3");
                        if (
                            that.allDuration != 0 &&
                            that.allDuration != NaN &&
                            that.currentDuration != 0
                        ) {
                            that.num = Math.ceil(
                                (that.currentDuration * 100) / that.allDuration
                            );
                            var remainingTime = that.allDuration - that.currentDuration;
                            that.jz(that.num);
                            that.sliderMoveLeft(that.currentDuration, that.allDuration);
                            that.currentPlayTime(remainingTime);
                        }
                        that.isloading = that.$store.state.isLoading = false;
                        that.loadingTxt = "";
                        this.loadingVoice = false;
                    },
                    false
                );
                this.myAudio.addEventListener("error", function() {
                    console.log("error");
                });
            },
            awardAcountFn() {
                //奖励已到账
                var qs = require("qs");
                this.awardTimer = setInterval(() => {
                    this.$http
                        .post(
                            "https://www.tmm6.cn/travelwalkman/timeByScenidsMaker/querySharedListenRecard",
                            qs.stringify({
                                userid: this.userId,
                                randomStr: this.randomStr,
                            })
                        )
                        .then((data) => {
                            if (data.state == 200) {
                                const result = data.res;
                                this.isAwardFlag = false;
                                this.awardTxt = result;
                                this.awardOpactiy = true;
                                setTimeout(() => {
                                    this.awardTxt = "";
                                    this.awardOpactiy = false;
                                }, 2500);
                                clearInterval(this.awardTimer);
                            } else if (data.state == 201) {
                                this.isAwardFlag = false;
                            }
                        });
                }, 10000);
            },
            timeByScenidsMaker(currentPlay, allDuration) {
                var scenicsDetails = this.scenicsMarker;
                var qs = require("qs");
                var data = {
                    userid: this.userId,
                    scenicsName: this.scenicName,
                    makerName: scenicsDetails[currentPlay].viewName,
                    duration: allDuration,
                    randomStr: this.randomStr,
                };
                this.$http
                    .post(
                        "https://www.tmm6.cn/travelwalkman/timeByScenidsMaker/durationByScenidsMaker",
                        qs.stringify(data)
                    )
                    .then((res) => {
                        console.log(res);
                    });
            },
            sliderMoveLeft(currentDuration, allDuration) {
                var sliderW = Math.ceil(
                    (currentDuration * this.lineDiv_width) / allDuration
                );
                this.minDivLeft = sliderW + "px";
                this.borderYellow = sliderW + "px";
            },
            removeLayer() {
                this.map.removeLayer(this.markers);
                this.map.removeLayer(this.markerDivs);
                // this.map.removeLayer(this.markersTag);
                this.map.removeLayer(this.markerDivsTag);
                this.map.removeLayer(this.polyline);
                this.map.removeLayer(this.myLayerGroup);
                //this.map.removeLayer(this.animatedMarker);
                this.myLayerGroup1.clearLayers();
                this.myLayerGroup2.clearLayers();
                this.myLayerGroup3.clearLayers();
                this.myLayerGroup4.clearLayers();
                //this.myLayerTag.clearLayers();
                //this.myLayerDivsTag.clearLayers();
            },
            currentPlayTime: function(remainingTime) {
                var maxtime = Math.ceil(remainingTime);
                var m =
                    Math.floor(maxtime / 60) * 1 < 10 ?
                    "0" + Math.floor(maxtime / 60) :
                    Math.floor(maxtime / 60) * 1;
                var s =
                    Math.floor(maxtime % 60) < 10 ?
                    "0" + Math.floor(maxtime % 60) :
                    Math.floor(maxtime % 60) * 1;
                this.timeTxt = m + ":" + s;
            },
            jz(num) {
                // console.log(num, "123123");
                //圆形进度条运动
                if (num <= 50) {
                    this.isDisplayR = "none";
                    this.circle = "rect(0, 50px, 50px, 25px)";
                } else {
                    this.isDisplayR = "block";
                    this.circle = "rect(auto, auto, auto, auto)";
                }
                if (num >= 100) {
                    num = 100;
                }
                this.rotateNum = Math.ceil((num * 360) / 100);
            },
            beisuTab(index) {
                this.multipleIndex = index;
                this.multipleIndexTxt = this.multipleArray[index];
                this.myAudio.playbackRate = this.multipleIndexTxt;
                this.isBeisuPull = false;
            },
            beisuPull() {
                if (!this.isBeisuPull) {
                    this.isBeisuPull = true;
                } else {
                    this.isBeisuPull = false;
                }
            },
            subDetailsListFn(index) {
                this.subDetailsListIndex = index;
                const date = new Date();
                const {
                    scenic,
                    uuid,
                    showType
                } = this.subDetails.list[index];
                let url = "";
                if (showType == 1) {
                    url = `https://www.tmm6.cn/travelwalkman/order/bigMap/index.html/?title=${scenic}&uuid=${uuid}&userid=${
          this.userid
        }&randomStr=''&v=${date.getTime()}/`;
                } else {
                    url = `https://www.tmm6.cn/travelwalkman/order/smallMap/index.html?title=${scenic}&uuid=${uuid}&userid=${
          this.userid
        }&randomStr=''&v=${date.getTime()}/`;
                }
                // https://tumaomao.miaodonglvxing.com/travelwalkman/order/testmap/index.html/?title=%E6%B8%85%E8%A5%BF%E9%99%B5&uuid=078fc342c8f747f48eed160398d68d56&userid=83857&randomStr=&v=1656141918072
                // https://tumaomao.miaodonglvxing.com/travelwalkman/order/testmap/index.html?title=%E5%8D%83%E5%B2%9B%E6%B9%96%E7%9F%B3%E6%9E%97%E6%99%AF%E5%8C%BA&uuid=9cf07bcdfb9d4c96a69d96445f8690c2&userid=undefined&randomStr=%27%27&v=1656142467182%2F
                // https://tumaomao.miaodonglvxing.com/travelwalkman/order/testmap/index.html?title=%E6%B8%85%E8%A5%BF%E9%99%B5&uuid=078fc342c8f747f48eed160398d68d56&userid=83857&randomStr=&v=1656142300256
                window.close();
                window.location.href = url;
                if (this.subDetailsModelFlag == -1) {
                    this.subDetailsModelFlag = -1;
                } else {
                    this.subDetailsModelFlag = 1;
                }
            },
            subDetailsModelFn() {
                if (this.subDetailsModelFlag == 2) {
                    this.subDetailsModelFlag = 1;
                } else {
                    this.subDetailsModelFlag = 2;
                }
            },
            museumFn() {
                this.isMuseum = true;
                this.isMuseumActive = true;
                this.subDetailsModelFlag = -1;
                if (this.currentPlayIndex != -1) {
                    this.myAudio.pause();
                    this.isPlayOrpause = true;
                    this.playOrpause = 0;
                    this.timeByScenidsMaker(this.currentPlayIndex, this.currentDuration);
                }
            },
            shibieflowersFn() {
                this.isShihuacaoActive = true;
                wx.miniProgram.getEnv((res) => {
                    console.log(res.miniprogram);
                });
                wx.miniProgram.navigateTo({
                    url: `/pages/shibieflowers/shibieflowers?uuid=${this.uuid}`,
                    success: function() {
                        console.log("success");
                    },
                    fail: function() {
                        console.log("fail");
                    },
                    complete: function() {
                        console.log("complete");
                    },
                });
                //wx.miniProgram.postMessage({ data: {uuid:this.uuid} })
            },
            onClicpopup() {
                if (this.scenics.length <= 0 && this.guidList.length <= 0) {
                    Toast('当前暂无播放文稿')
                } else {
                    this.Exhibitsindex = 0
                    this.storyList = []
                    this.scenicsMarker = this.scenicAuxiliary.scenics;
                    this.storyList = this.scenicAuxiliary.scenics;
                    this.Landmark = `景点(${this.storyList.length}个)`
                    this.sheshiMarker = this.scenicAuxiliary.facilities;
                    if (this.Exhibitsindex == 1) {
                        this.$refs.audio.pause();
                        this.isPlaying = false;
                        this.progressBarIndex = -1
                    }
                    this.isexplain = true
                }
                return
                this.tableIndex = 0;
                this.$refs.Popup.showCssPopup(true, this.scenicsMarker, 1);
            },
            introEvent() {
                this.tableIndex = 2;
                this.$refs.Popup.showCssPopup(true, this.intro, 2);
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .dingweipng {
        z-index: 100000 !important;
    }

    .acrive-mast {
        width: 0.6rem;
        height: 0.35rem;
        position: relative;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: -1.24rem;
    }

    .Popup-box {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .network {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .network-model {
            width: 3.14rem;
            font-size: 0.28rem;

            .network-img {
                width: 3.14rem;
                height: 2.54rem;
                background: url(../../static/img/wlxinhao.png) no-repeat;
                background-size: cover;
            }

            .network-txt {
                text-align: center;
                line-height: 0.6rem;
            }

            .network-btn {
                text-align: center;
                line-height: 0.6rem;
                color: rgba(253, 78, 82, 1);
            }
        }
    }

    .sub-details-model {
        width: 100%;
        height: auto;
        max-height: 0;
        position: fixed;
        left: 0;
        top: 0rem;
        background: rgba(255, 255, 255, 0.9);
        padding: 0 0.5rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        overflow-y: scroll;

        .sub-details-list {
            width: 100%;
            height: 0.9rem;
            box-sizing: border-box;
            border-bottom: 0.01rem solid #c5c5c5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(0, 0, 0, 1);

            .icon {
                width: 0.5rem;
                height: 0.5rem;
                background: url(../../static/img/sub-details-right.png) no-repeat;
                background-size: cover;
            }
        }

        .sub-details-list:last-child {
            margin-bottom: 0.4rem;
        }

        .sub-details-list.active {
            color: rgba(213, 94, 37, 1);

            .icon {
                background: url(../../static/img/sub-details-right-active.png) no-repeat;
                background-size: cover;
            }
        }
    }

    .sub-details-model.animateIn {
        animation: slideIn 0.5s forwards;
    }

    .sub-details-model.animateOut {
        animation: slideOut 0.5s forwards;
    }

    @keyframes slideIn {
        0% {
            max-height: 0px;
        }

        100% {
            max-height: 5rem;
        }
    }

    @keyframes slideOut {
        0% {
            max-height: 5rem;
        }

        100% {
            max-height: 0;
        }
    }

    .my-num {
        width: 20px !important;
        height: 20px !important;
        line-height: 20px !important;
        margin-left: -10px !important;
        margin-top: -10px !important;
    }

    .line-img {
        margin-top: -55px !important;
        z-index: 100022 !important;
    }

    .maps,
    .hello {
        width: 7.5rem;
        height: 100%;
    }

    .border-box {
        width: 5.5rem;
        height: 0.03rem;
        background: rgba(170, 170, 170, 0);
        position: fixed;
        left: 0;
        top: 0;
    }

    .voice-lists-play-box {
        width: 100%;
        height: 0.03rem;
        background: rgba(170, 170, 170, 0);
        position: fixed;
        left: 0;
        top: 0;
    }

    .my-div-icon {
        width: 3.5rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        margin-left: -1.75rem !important;
        text-align: center !important;
        margin-top: 0.25rem !important;
    }

    .my-div-iconmg {
        width: 3.5rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        margin-left: -1.75rem !important;
        text-align: center !important;
        margin-top: -0.1rem !important;
    }

    .my-div-iconTag {
        width: 3.5rem !important;
        height: 0.4rem !important;
        line-height: 0.3rem !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        margin-left: -1.75rem !important;
        text-align: center !important;
        margin-top: 0.15rem !important;
    }

    .div-icon {
        height: 0.28rem;
        line-height: 0.28rem;
        display: inline-block;
        font-size: 0.2rem;
        text-align: center;
        // max-width: 2.88rem!important;
        background: linear-gradient(to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.8) 25%,
                rgba(255, 255, 255, 0.8) 50%,
                rgba(255, 255, 255, 0.8) 75%,
                rgba(255, 255, 255, 0) 100%);
        padding: 0 0.2rem;
        color: #753300;
    }

    .div-icontag {
        height: 0.28rem;
        line-height: 0.28rem;
        display: inline-block;
        font-size: 0.2rem;
        text-align: center;
        // max-width: 2.88rem!important;
        background: linear-gradient(to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.5) 25%,
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0.5) 75%,
                rgba(255, 255, 255, 0) 100%);
        padding: 0 0.2rem;
        color: #753300;
    }

    .div-icon-line {
        display: inline;
        padding: 0.05rem 0.12rem !important;
        box-sizing: border-box !important;
        background: rgba(255, 255, 255, 0.8);
        // border: 1px solid #383838;
        border-radius: 0.5rem;
        font-size: 0.2rem;
        text-align: center;
    }

    .div-iconTag {
        font-size: 0.2rem;
        box-sizing: border-box;
        color: #7f946e;
        border: none;
        background: none;
        /*text-shadow:#fff 1px 0 0, #fff 0 1px 0, #fff -1px  0 0, #fff 0 -1px  0;*/
        text-shadow: 0px 0px 2px #fff;
        /*text-shadow:1px 1px 3px #fff;*/
        font-weight: 800;
        z-index: 99999;
        overflow: auto;
    }

    .beisu {
        width: 0.8rem;
        height: 0.6rem;
        border-radius: 0.2rem;
        background: rgba(255, 255, 255, 0.7);
        position: fixed;
        right: 2.2rem;
        bottom: 1.4rem;
        font-size: 0.24rem;
        overflow: hidden;
        z-index: 1;

        .beisu-val {
            width: 0.8rem;
            height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            color: #ff5155;
            font-weight: 700;
        }

        ul {
            width: 0.8rem;
            height: 0rem;
            display: flex;
            flex-flow: column;
            border-radius: 0.2rem;
            overflow: hidden;

            li {
                text-align: center;
                line-height: 0.6rem;
                border-bottom: 0.01rem solid #eee;
                box-sizing: border-box;
                font-size: 0.2rem;
            }

            li.active {
                color: #ff5155;
            }

            //li:last-child{
            //	border:0;
            //}
        }
    }

    .footer {
        width: 78px;
        height: 80px;
        position: fixed;
        left: 50%;
        bottom: 0.64rem;
        margin-left: -39px;
        padding: 0rem 0rem 0.35rem;
        // box-sizing: border-box;
        font-size: 0.2rem;

        .footer-c {
            width: 78px;
            height: 80px;
            margin: 0 auto 0;
            display: flex;
            display: -webkit-flex;

            .footer-ltem {
                flex: 1;
                text-align: center;
                background: url(../../static/img/play.png) no-repeat;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .footer-ltem.active {
                background: url(../../static/img/pause.png) no-repeat;
                background-size: cover;
            }

            .play_audio {
                width: 50px;
                height: 50px;
                border-radius: 60px;
                margin: 0 auto;
                position: relative;
                margin-top: -3.5px;
            }
        }
    }

    .nav-explain {
        width: 90%;
        position: absolute;
        bottom: 0.2rem;
        background: #fff;
        border-radius: 7px;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-size: 0.3rem;
        display: flex;
        align-items: center;
        padding: 0.2rem 0;

        .__active {
            position: relative;
        }

        .__active_boreder {
            position: absolute;
            width: 2.24rem;
            height: 0.4rem;
            left: -0.1rem;
            top: 0.1rem;
            border-left: 1px solid #ccc;
            border-right: 1px solid #ccc;
            // border: 1px solid #000;
        }

        ._nav_active {
            background: rgba(238, 238, 238, 0.6);
        }

        >div {
            display: flex;
            flex: 1;
            justify-content: center;

            >div {
                display: flex;
                align-items: center;
                border-radius: 0.4rem;
                padding: 0.1rem 0.2rem;
                box-sizing: border-box;
                box-sizing: border-box;
                justify-content: center;

                .item-icon {
                    width: 0.4rem;
                    height: 0.4rem;
                    margin-right: 4px;
                }

                .item-icon3 {
                    width: 0.32rem;
                }
            }
        }
    }

    .museum {
        background: url(../../static/img/guancang.png) no-repeat;
        background-size: cover;
    }

    .museum.active {
        background: url(../../static/img/guancang-active.png) no-repeat;
        background-size: cover;
    }

    .nav-btns {
        width: 0.96rem;
        height: auto;
        // background: rgba(255, 255, 255, 1);
        // box-shadow: 0rem 0.03rem 0.03rem 0.01rem rgba(111, 8, 8, 0.17);
        // border-radius: 0.4rem;
        position: absolute;
        right: 0.3rem;
        top: 11%;
        // padding: 0.11rem 0.11rem;
        // box-sizing: border-box;
        font-size: 0.18rem;
        color: #656565;

        // display: flex;
        // flex-flow: column;
        .btns_list {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 5px !important;

            >span {
                font-size: 0.2rem !important;
                transform: scale(0.78);
                position: relative;
                top: -2px;
            }

            .btns_list-icon {
                width: 0.37rem;
                height: 0.37rem;
            }
        }

        .btn {
            width: 0.96rem;
            height: 0.96rem;
            padding-top: 0.18rem;
            box-sizing: border-box;
            background: url(../../static/img/btn-bg.png) no-repeat;
            background-size: cover;
            display: inline-flex;
            flex-flow: column;
            text-align: center;
            align-items: center;
            margin-bottom: 0.06rem;

            .btn-icon {
                width: 0.6rem;
                height: 0.44rem;
            }

            .btn-name.active {
                color: #f62a42;
            }

            // .btn-jingdian {
            // 	background: url(../../static/img/jingdian.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-jingdian.active {
            // 	background: url(../../static/img/jingdian-active.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-sheshi {
            // 	background: url(../../static/img/sheshi.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-sheshi.active {
            // 	background: url(../../static/img/sheshi-active.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-liebiao {
            // 	background: url(../../static/img/liebiao.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-liebiao.active {
            // 	background: url(../../static/img/liebiao-active.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-luxian {
            // 	background: url(../../static/img/luxian.png) no-repeat;
            // 	background-size: cover;
            // }

            // .btn-luxian.active {
            // 	background: url(../../static/img/luxian-active.png) no-repeat;
            // 	background-size: cover;
            // }
        }

        .scenic {
            background: url(../../static/img/jingdian.png) no-repeat;
            background-size: cover;
        }

        .scenic.active {
            background: url(../../static/img/jingdian-active.png) no-repeat;
            background-size: cover;
        }

        .line {
            background: url(../../static/img/luxian.png) no-repeat;
            background-size: cover;
        }

        .line.active {
            background: url(../../static/img/luxian-active.png) no-repeat;
            background-size: cover;
        }

        .jubu {
            background: url(../../static/img/jubu.png) no-repeat;
            background-size: cover;
        }

        .jubu.active {
            background: url(../../static/img/jubu-active.png) no-repeat;
            background-size: cover;
        }

        .shihuacao {
            background: url(../../static/img/shihuacao.png) no-repeat;
            background-size: cover;
        }

        .shihuacao.active {
            background: url(../../static/img/shihuacao-active.png) no-repeat;
            background-size: cover;
        }

        .shift-e-c {
            background: url(../../static/img/yuyan.png) no-repeat;
            background-size: cover;
        }

        .shift-e-c.active {
            background: url(../../static/img/yuyan-active.png) no-repeat;
            background-size: cover;
        }

        .btn:last-child {
            border-bottom: 0;
        }
    }

    .nav-btns.animateLeft {
        right: -1rem;
        transition: right 0.6s;
    }

    .nav-btns.animateLRight {
        right: 0.3rem;
        transition: left 0.8s;
    }

    .rescue {
        width: 1rem;
        height: auto;
        position: absolute;
        right: 0.34rem;
        top: 2.08rem;

        .jy1 {
            width: 1rem;
            height: 1rem;
        }

        .jy2 {
            width: 0.97rem;
            height: 0.31rem;
            margin-top: 0.2rem;
        }
    }

    .roll-slider {
        width: 7.5rem;
        height: 0.5rem;
        position: fixed;
        left: 50%;
        top: 0rem;
        margin-left: -3.75rem;
        background: rgba(255, 255, 255, 0.71);
        padding: 0 1.1rem;
        box-sizing: border-box;

        .roll-model {
            color: #fc5e47;
            font-size: 0.22rem;
            line-height: 0.5rem;
        }

        .roll-icon {
            width: 0.4rem;
            height: 0.4rem;
            background: url(../../static/img/gb.png) no-repeat;
            background-size: cover;
            position: absolute;
            left: 0.33rem;
            top: 0.05rem;
        }
    }

    .zoom-tap {
        width: 0.96rem;
        padding: 0 0.08rem;
        box-sizing: border-box;
        overflow: hidden;
        position: absolute;
        right: 0.3rem;
        top: 66%;
        display: flex;
        flex-direction: column;
        align-items: center;

        &.zoom-left {
            left: 0.3rem;
        }

        .max-zoom {
            width: 0.8rem;
            height: 0.8rem;
            background: url(../../static/img/maxZoom.png) no-repeat;
            background-size: cover;
        }

        .max-zoom.active {
            background: url(../../static/img/maxZoom-active.png) no-repeat;
            background-size: cover;
        }

        .min-zoom {
            width: 0.8rem;
            height: 0.8rem;
            background: url(../../static/img/minZoom.png) no-repeat;
            background-size: cover;
            margin-top: 0.3rem;
        }

        .min-zoom.active {
            background: url(../../static/img/minZoom-active.png) no-repeat;
            background-size: cover;
        }
    }

    .zoom-tap_a {
        top: 10%;
    }

    .zoom-tap.animateLeft {
        right: -1rem;
        transition: right 0.6s;
    }

    .zoom-tap.animateLRight {
        right: 0.3rem;
        transition: left 0.8s;
    }

    .minOrMaxHint {
        width: 100%;
        height: 0.6rem;
        position: fixed;
        left: 0;
        top: 48%;

        .minOrMaxModel {
            width: 100%;
            height: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;

            p {
                width: auto;
                height: 100%;
                border-radius: 0.1rem;
                background: rgba(0, 0, 0, 0.5);
                color: #fff;
                text-align: center;
                line-height: 0.6rem;
                font-size: 0.24rem;
                padding: 0 0.2rem;
            }
        }
    }

    .in-or-out {
        width: 3.6rem;
        height: 0.5rem;
        font-size: 0.27rem;
        text-align: center;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0.1rem;
        position: fixed;
        left: 50%;
        bottom: 45%;
        margin-left: -1.8rem;
        color: #fff;
        line-height: 0.5rem;
        padding: 0 0.2rem;
        box-sizing: border-box;
    }

    .isplay {
        width: 7.5rem;
        height: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        position: fixed;
        left: 50%;
        top: 0;
        background: rgba(0, 0, 0, 0.2);
        z-index: 4;
        margin-left: -3.75rem;

        /*display: none;*/
        .isplayModel {
            width: 5.5rem;
            overflow: hidden;
            text-align: center;
            padding: 0.3rem 0.5rem 0 0.5rem;
            box-sizing: border-box;
            margin-top: 4.5rem;
            background: #fff;
            font-size: 0.28rem;
            border-radius: 0.05rem;

            p {
                line-height: 0.4rem;
                color: #686868;
            }

            .title {
                font-size: 0.32rem;
                line-height: 0.6rem;
                margin-bottom: 0.1rem;
                font-weight: 700;
                text-align: left;
            }

            ul {
                width: 100%;
                height: 1rem;
                display: flex;
                display: -webkit-flex;
                color: #000;

                li {
                    flex: 2;
                    line-height: 1rem;
                    font-size: 0.28rem;
                }

                li.active {
                    color: #5c985c;
                }
            }
        }
    }

    .self-motion.animateLeft {
        left: -1rem;
        transition: left 0.6s;
    }

    .animate-left {
        left: -1rem !important;
        transition: left 0.6s;
    }

    .self-motion.animateLRight {
        left: 0.3rem;
        transition: left 0.8s;
    }

    .self-motion {
        width: 0.96rem;
        height: 0.96rem;
        // background: url(../../static/img/pos.png) no-repeat;
        // background-size: cover;
        // position: absolute;
        // right: 0.3rem;
        // top:3.66rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .radio {
            width: 100%;
            height: 100%;
            background: url(../../static/img/unchenked.png) no-repeat;
            background-size: cover;
        }

        .radio.active {
            background: url(../../static/img/checked.png) no-repeat;
            background-size: cover;
        }

        // .slider {
        // 	width: 28px;
        // 	height: 16px;
        // 	border-radius: 15px;
        // 	border: 2px solid #bbb;
        // 	box-sizing: border-box;
        // 	margin-bottom: 0.06rem;

        // 	.slider-btn {
        // 		width: 10px;
        // 		height: 10px;
        // 		border-radius: 10px;
        // 		background: #bbb;
        // 		margin-top: 1px;
        // 		margin-left: 1px;
        // 	}

        // 	.slider-btn.activer {
        // 		background: #F52240;
        // 		margin-left: 13px;
        // 		transition: margin-left 0.2s;
        // 	}
        // }

        // .slider.active {
        // 	border-color: #F52240;
        // }
    }

    // .location {
    // 	width: 0.93rem;
    // 	height: 0.93rem;
    // 	background: url(../../static/img/pos.png) no-repeat;
    // 	background-size: cover;
    // 	position: absolute;
    // 	left: 0.27rem;
    // 	bottom: 1.57rem;

    // 	.location-box {
    // 		width: 0.4rem;
    // 		height: 0.4rem;
    // 		position: absolute;
    // 		left: 0.27rem;
    // 		top: 0.24rem;
    // 		background: url(../../static/img/weizhi.png) no-repeat;
    // 		background-size: cover;
    // 	}

    // 	.location-box.active {
    // 		width: 0.82rem;
    // 		height: 0.82rem;
    // 		position: absolute;
    // 		left: 0.06rem;
    // 		top: 0.02rem;
    // 		background: url(../../static/img/weizhi.gif) no-repeat;
    // 		background-size: cover;
    // 	}
    // }

    .voice-lists-model {
        width: 100%;
        height: 100%;
        background: rgba(56, 56, 56, 0.2);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 3;

        /*display: none;*/
        .voice-lists-play {
            width: 100%;
            max-height: 9.58rem;
            position: absolute;
            left: 0;
            bottom: 0;

            .title {
                width: 100%;
                height: 0.8rem;
                text-align: center;
                line-height: 0.8rem;
                font-size: 14px;
                background: rgba(255, 255, 255, 0.9);
                position: absolute;
                left: 0;
                top: 0;
                z-index: 2;
            }

            ul {
                width: 100%;
                max-height: 9.58rem;
                overflow: scroll;
                padding: 0 0.44rem;
                padding-bottom: 1.18rem;
                box-sizing: border-box;
                -webkit-box-sizing: border-box;
                background: rgba(255, 255, 255, 1);

                li {
                    width: 100%;
                    height: 1.1rem;
                    border-bottom: 0.02rem solid rgba(170, 170, 170, 0.2);
                    display: flex;
                    display: -webkit-flex;
                    justify-content: center;
                    overflow: hidden;

                    .voice-list-l {
                        width: 6rem;
                        height: 100%;
                        font-size: 0.28rem;
                        position: relative;
                        display: flex;
                        display: -webkit-flex;
                        justify-content: space-between;
                        align-items: center;

                        .txt {
                            width: 4rem;
                            height: auto;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            position: absolute;
                            top: 0.4rem;
                        }

                        .animate {
                            animation: animate 1s forwards;
                            -webkit-animation: animate 1s forwards;
                            /* Safari 与 Chrome */
                        }

                        .time {
                            width: auto;
                            height: auto;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            position: absolute;
                            top: 0.2rem;
                            right: 0;
                            font-size: 0.2rem;
                        }
                    }

                    .voice-list-r {
                        width: 1rem;
                        height: 100%;
                        display: inline-flex;
                        display: -webkit-inline-flex;
                        justify-content: flex-end;
                        align-items: center;
                        font-size: 0.24rem;

                        i {
                            width: 0.73rem;
                            height: 0.73rem;
                            background: url(../../static/img/pause1-voice.png) no-repeat;
                            background-size: cover;
                        }

                        i.backg1 {
                            background: url(../../static/img/pause-voice.png) no-repeat;
                            background-size: cover;
                        }

                        i.backg2 {
                            background: url(../../static/img/play-voice.png) no-repeat;
                            background-size: cover;
                        }
                    }

                    .slider {
                        width: 5.5rem;
                        height: 0.53rem;
                        position: absolute;
                        left: 0;
                        bottom: 0.13rem;
                        transform: scale(0);
                        -webkit-transform: scale(0);

                        .border {
                            width: 5.5rem;
                            height: 0.03rem;
                            background: rgba(170, 170, 170, 0.3);
                            position: absolute;
                            left: 0.2rem;
                            top: 0.25rem;
                        }

                        .border-yellow {
                            width: 0.2rem;
                            height: 0.03rem;
                            background: rgba(248, 102, 89, 1);
                            position: absolute;
                            left: 0.2rem;
                            top: 0.25rem;
                        }

                        .move {
                            width: 0.4rem;
                            height: 0.5rem;
                            background: url(../../static/img/slider.png) no-repeat;
                            background-size: cover;
                            z-index: 2;
                            position: absolute;
                            left: 0rem;
                            top: 0.05rem;
                        }
                    }

                    .scaleAniamte {
                        animation: scaleAniamte 1s forwards;
                        -webkit-animation: scaleAniamte 1s forwards;
                        /* Safari 与 Chrome */
                    }
                }
            }

            .voice-footer {
                width: 100%;
                height: 1.18rem;
                display: flex;
                display: -webkit-flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                left: 0;
                bottom: 0;
                background: rgba(255, 255, 255, 0.9);

                p {
                    width: 0.4rem;
                    height: 0.4rem;
                    background: url(../../static/img/close.png) no-repeat;
                    background-size: cover;
                }
            }
        }
    }

    .voice-lists.active {
        background: rgba(246, 74, 74, 1);

        span {
            color: #fff;
        }
    }

    .wrap,
    .circle,
    .num {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        box-shadow: -0.5px 3px 10px RGBA(255, 255, 255, 0);
        -webkit-box-shadow: -0.5px 3px 10px RGBA(255, 255, 255, 0);
    }

    .wrap {
        position: absolute;
        left: 0px;
        top: 0px;
    }

    .circle {
        position: absolute;
        top: 2px;
        left: 0px;
        box-sizing: border-box;
    }

    .circle div {
        width: 50px;
        height: 50px;
        position: absolute;
        box-sizing: border-box;
        border-radius: 50%;
    }

    .left {
        clip: rect(0, 25px, 50px, 0);
        border: 4px solid RGBA(246, 74, 74, 1);
    }

    .right {
        clip: rect(0, 50px, 50px, 25px);
        border: 4px solid RGBA(246, 74, 74, 1);
    }

    .isCurrentPlaying {
        width: 100%;
        height: 0.5rem;
        position: fixed;
        left: 0%;
        bottom: 2.4rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        display: flex;
        display: -webkit-flex;
        box-sizing: border-box;
        justify-content: center;
        z-index: 2;

        p {
            width: auto;
            height: 0.5rem;
            display: inline-block;
            text-align: center;
            line-height: 0.5rem;
            color: #ffffff;
            border-radius: 0.5rem;
            background: rgba(0, 0, 0, 0.6);
            font-size: 14px;
            margin: 0 auto;
            padding: 0 0.25rem;
            box-sizing: border-box;
            justify-content: center;
        }
    }

    .current-img {
        width: 7.5rem;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 4;
        transform: scale(0);
        -webkit-transform: scale(0);
        -moz-transform: scale(0);
        -o-transform: scale(0);

        img {
            width: 7.5rem;
            height: 9rem;
            position: absolute;
            left: 0;
            top: 2rem;
            pointer-events: none;
        }
    }

    .current-img.scaleIn,
    .isCurrentPlaying.scaleIn {
        animation: scaleIn 1s forwards;
        -webkit-animation: scaleIn 1s forwards;
        /* Safari 和 Chrome */
    }

    .current-img.scaleOut,
    .isCurrentPlaying.scaleOut {
        animation: scaleOut 1s forwards;
        -webkit-animation: scaleOut 1s forwards;
        /* Safari 和 Chrome */
    }

    @keyframes scaleIn {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }
    }

    @-moz-keyframes scaleIn {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }
    }

    @-webkit-keyframes scaleIn {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }
    }

    @-o-keyframes scaleIn {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }
    }

    @keyframes scaleOut {
        from {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }

        to {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }
    }

    @-moz-keyframes scaleOut {
        from {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }

        to {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }
    }

    @-webkit-keyframes scaleOut {
        from {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }

        to {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }
    }

    @-o-keyframes scaleOut {
        from {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -o-transform: scale(1);
        }

        to {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0);
            -o-transform: scale(0);
        }
    }

    @keyframes animate {
        from {
            top: 0.4rem;
            font-size: 0.28rem;
        }

        to {
            top: 0.2rem;
            font-size: 0.2rem;
        }
    }

    @-moz-keyframes animate {
        from {
            top: 0.4rem;
            font-size: 0.28rem;
        }

        to {
            top: 0.2rem;
            font-size: 0.2rem;
        }
    }

    @-webkit-keyframes animate {
        from {
            top: 0.4rem;
            font-size: 0.28rem;
        }

        to {
            top: 0.2rem;
            font-size: 0.2rem;
        }
    }

    @-o-keyframes animate {
        from {
            top: 0.4rem;
            font-size: 0.28rem;
        }

        to {
            top: 0.2rem;
            font-size: 0.2rem;
        }
    }

    @keyframes scaleAniamte {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
        }
    }

    @-moz-keyframes scaleAniamte {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
        }
    }

    @-webkit-keyframes scaleAniamte {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
        }
    }

    @-o-keyframes scaleAniamte {
        from {
            transform: scale(0);
            -webkit-transform: scale(0);
        }

        to {
            transform: scale(1);
            -webkit-transform: scale(1);
        }
    }

    .awardtxt {
        width: 100%;
        display: flex;
        justify-content: center;

        line-height: 0.5rem;

        color: #fff;
        position: fixed;
        top: 50%;
        display: none;

        p {
            padding: 0 0.3rem;
            display: inline-block;
            width: auto;
            border-radius: 0.3rem;
            text-align: center;
            background: rgba(0, 0, 0, 0.6);
        }
    }

    .awardtxt.active {
        display: flex;
    }

    .navtitle_box {
        position: fixed;
        z-index: 1002;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
        font-weight: bold;
        width: 100%;
        // padding-bottom: 12px;
        // padding-top: 12px;
        box-sizing: border-box;
    }

    .dia {
        display: flex;
        align-items: center;

    }

    .dis {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .arrow_left {
        position: absolute;
        top: 50%;
        left: 17px;
        transform: translateY(-50%);

        img {
            width: 8px;
            height: 16px;
            // margin-left: 17px;
        }
    }

    .navtitle_name {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .overlay_video {
        --van-overlay-background: rgba(0, 0, 0, 0.1) !important;
    }

    .explainList_box {
        width: 100%;
        height: 400px;
        background-color: #fff;
        border-radius: 24px 24px 0px 0px;
        // z-index: 1001;
        padding: 0px 14px;
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        z-index: 10002;

        .tabs_box {
            width: 180px;
        }

        .succession {
            margin-top: 15px;

            .succession_play {
                margin-top: 4px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 9rpx;
                color: #767676;
            }
        }

        .selfWorry {
            font-family: PingFang SC PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            margin-top: 18px;
            width: 100%;
            height: 300px;
            overflow: scroll;
            touch-action: auto;
            /* 确保触摸事件不会被阻止 */
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;

            /* IE/Edge */
            /* 启用原生滚动 */
            .characters_image {
                width: 20px;
                height: 20px;
            }

            .characters {
                margin-right: 20px;

            }


            .selfWorry_box {
                margin-top: 8px;
            }

            .selfWorry_boxs {
                margin-top: 14px;
            }

            .controls {
                display: flex;
                flex-direction: column;
                align-items: center;

                // position: absolute;
                // padding: 0px 4px;
                // top: 18px;
                // box-sizing: border-box;
                .progress-bar {
                    width: 100%;
                    height: 4px;
                    background-color: #e5d4c0;
                    border-radius: 5px;
                    margin-top: 10px;
                    position: relative;
                    cursor: pointer;

                }

                .progress {
                    height: 100%;
                    background-color: #9B6C34;
                    border-radius: 5px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                .thumb {
                    width: 8px;
                    height: 8px;
                    background-color: #9B6C34;
                    border-radius: 50%;
                    position: absolute;
                    top: -2px;
                    left: 0;
                    transform: translateX(-50%);
                    cursor: pointer;
                }
            }
        }

        .music-player {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .music-player_boxs {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            // background: linear-gradient( 180deg, #FFFFFF 0%, #FBE5CF 100%);
            // width: 124px;
            // height: 124px;
            // background: rgba(255,255,255,0.5);
            border: 8px solid rgba(255, 255, 255, 0.5);
        }

        .progress-circle {
            width: 40px;
            height: 40px;
            position: relative;

            .progress-circle_box {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: linear-gradient(180deg, #FFFFFF 0%, #FBE5CF 100%);
                position: absolute;
                top: 10%;
                left: 50%;
                transform: translate(-50%, 0%);

                .transmit {
                    margin-left: 4px;
                }

                img {
                    width: 16px;
                    height: 16px;

                }
            }
        }

        .progress-circle-bar {
            stroke: #AE5A3D;
            transition: stroke-dashoffset 0.3s;
        }

    }

    .overlay_line {
        --van-overlay-background: rgba(0, 0, 0, 0.3) !important;
    }

    .lineBox {
        width: 253px;
        height: 282px;
        // background: linear-gradient( 180deg, #FEEED7 0%, #FFFFFF 100%);
        // border: 1px solid #BBA993;
        padding-top: 40px;
        padding-bottom: 32px;
        padding-left: 48px;
        padding-right: 48px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-image: url('https://rgkj-oss.oss-cn-heyuan.aliyuncs.com/tumao/smallImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20241130172928.png');
        background-repeat: no-repeat;
        background-size: 253px 282px;

        .package {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #1A1A1A;
            margin-top: 16px;
        }

        .size {
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            font-size: 13px;
            color: #767676;
            margin-top: 12px;
        }

        .folder {
            width: 49px;
            height: 49px;
        }

        .btn {
            width: 157px;
            height: 49px;
            background: transparent;
            border-radius: 4px;
            font-family: Source Han Serif CN, Source Han Serif CN;
            font-weight: 600;
            font-size: 18px;
            color: #FFFFFF;
            margin-top: 40px;
            position: relative;
            // z-index: 99999;
            // animation: fillBackground 2s ease-in-out forwards;
            /* 默认动画持续时间 */
        }

        .btn_animation {
            background-color: #9B6C34;
        }

        .btn_tran {
            background-color: transparent;
        }

        /* 在 App.vue 或单独的 CSS 文件中定义样式 */
        // .box {
        // 	width: 200px;
        // 	height: 200px;
        // 	background-color: transparent;
        // 	border: 1px solid #000;
        // 	position: relative;
        // 	overflow: hidden;
        // }

        .progress-bars {
            height: 100%;
            background-color: #9B6C34;
            border-radius: 4px;
            /* 目标背景色 */
            position: absolute;
            top: 0;
            left: 0;
            width: 0;
            /* 初始宽度为0 */
            transition: width 0.5s ease-in-out;

            /* 过渡效果 */
        }

        .boundary-overlay {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            /* 设置为黑色，透明度为0.5 */
            pointer-events: none;
            /* 防止覆盖层阻挡鼠标事件 */
        }

        .prepare {
            position: absolute;
            top: 32px;
            left: 24px;
        }
    }

    ::v-deep .explainList_box .selfWorry img {
        width: 80px !important;
        height: 80px !important;
    }

    .slider-container {
        width: 346px;
        position: relative;
    }

    input[type="range"] {
        -webkit-appearance: none;
        width: 100%;
        height: 4px;
        background: transparent;
        position: relative;
        z-index: 2;
    }

    input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 8px;
        height: 8px;
        background: #9B6C34;
        border-radius: 50%;
        cursor: pointer;
    }

    .slider-fill {
        position: absolute;
        top: 36%;
        left: 0;
        height: 4px;
        background: #e5d4c0;
        border-radius: 5px;
        transform: translateY(-50%);
        z-index: 1;
    }

    .navtitle {
        width: 100%;
        z-index: 1002;
        color: #333;
        top: 0;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #1A1A1A;
        font-weight: bold;

        .navtitle_box {
            position: fixed;
            z-index: 1002;
            width: 100%;
            padding-bottom: 12px;
            padding-top: 12px;
            box-sizing: border-box;
        }

        img {
            width: 8px;
            height: 14px;
            margin-left: 17px;
        }

        .navtitle_name {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .introduction_box {
        margin-top: 14px;

        .introduction {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #1A1A1A;
        }

        img {
            width: 40px;
            height: 40px;
        }

        .draft_left {
            margin-right: 16px;
        }

        .draft_right {
            margin-left: 16px;
        }
    }

    .programme {
        padding: 0px 10px;
        box-sizing: border-box;
        margin-top: 4px;

        .programme_box {
            width: 100%;
            height: 65vh;
            background-image: url(/src/assets/images/orientation_bac.png);
            background-repeat: no-repeat;
            background-size: 100% 70vh;
            padding: 17px 16px;
            box-sizing: border-box;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #1A1A1A;

            .programme_swiper {
                width: 100%;
                overflow-y: auto;
                height: 66vh;
                line-height: 26px;
                overflow: -moz-scrollbars-none;
                /* Firefox */
                scrollbar-width: none;
                /* Firefox */
                -ms-overflow-style: none;
                /* IE/Edge */
            }

            .programme_swiper::-webkit-scrollbar {
                display: none;
            }
        }
    }

    .playBack {

        .controls {
            display: flex;
            flex-direction: column;
            align-items: center;

            // position: absolute;
            // padding: 0px 4px;
            // top: 18px;
            // box-sizing: border-box;
            .progress-bar {
                width: 100%;
                height: 4px;
                background-color: #e5d4c0;
                border-radius: 5px;
                margin-top: 10px;
                position: relative;
                cursor: pointer;

            }

            .progress {
                height: 100%;
                background-color: #9B6C34;
                border-radius: 5px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .thumb {
                width: 8px;
                height: 8px;
                background-color: #9B6C34;
                border-radius: 50%;
                position: absolute;
                top: -2px;
                left: 0;
                transform: translateX(-50%);
                cursor: pointer;
            }
        }

        .player-progress {
            width: 100%;
            padding: 0px 17px;
            box-sizing: border-box;
        }

        .progress-bar {
            width: 100%;
            margin-right: 10px;
            -webkit-appearance: none;
            appearance: none;
            background: transparent;
            height: 5px;
        }

        .progress-bar::-webkit-slider-runnable-track {
            width: 100%;
            height: 5px;
            background: linear-gradient(to right, #9B6C34 var(--progress), #e5d4c0 var(--progress));
            border-radius: 3px;
        }

        .progress-bar::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 10px;
            height: 10px;
            background: #9B6C34;
            border-radius: 50%;
            cursor: pointer;
            margin-top: -3px;
        }

        .progress-bar::-moz-range-track {
            width: 100%;
            height: 5px;
            background: linear-gradient(to right, #9B6C34 var(--progress), #e5d4c0 var(--progress));
            border-radius: 3px;
        }

        .progress-bar::-moz-range-thumb {
            width: 15px;
            height: 15px;
            background: #9B6C34;
            border-radius: 50%;
            cursor: pointer;
        }

        .time-display {
            font-size: 14px;
            color: #333;
            margin-top: 10px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #767676;
        }

        .variable {
            width: 20px;
            height: 20px;
        }

        .speed_box {
            position: relative;
            margin-top: 24px;
            // padding: 0px 47px;
            box-sizing: border-box;

            .characters {
                margin-left: 32px;

                .characters_image {
                    width: 20px;
                    height: 20px;
                }
            }

        }

        .transmit_left {
            width: 47px;
            height: 47px;
        }

        .play_draft {
            width: 24px;
            height: 24px;
            margin-left: 6px;
        }

        .play_back {
            width: 16px;
            height: 16px;
        }

        .play_transmit {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            background-color: #9b6c34;
        }

        .more {
            width: 24px;
            height: 24px;
        }
    }

    .warrp_navtitle {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        background: linear-gradient(180deg, #F6E9D8 0%, #FDF7F0 98%);
        z-index: 100001 !important;
        padding-top: 34px;
        box-sizing: border-box;

        .close_box {
            margin-left: 24px;

            .close {
                width: 24px;
                height: 24px;
            }
        }

        .characters_image {
            width: 20px;
            height: 20px;
        }


    }

    .overlay {
        --van-overlay-background: rgba(0, 0, 0, 0.4) !important;

        .explain {
            position: absolute;
            // top: 68px;
            background-color: #fff;
            width: 100%;
            padding: 12px 0px 18px 0px;
            z-index: 9999;
            box-sizing: border-box;
            border-radius: 0px 0px 12px 12px;

            .commentator {
                font-family: PingFang SC, PingFang SC;
                font-weight: 800;
                font-size: 14px;
                color: #1A1A1A;
                margin-top: 24px;
            }

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
            }

            .explain_increase {
                margin-left: 18px;
                margin-top: 18px;

                .explain_name {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #333333;
                    margin-top: 6px;
                    padding: 1px 6px;
                    box-sizing: border-box;
                    border-radius: 40px;
                }

                .scenicsRecorder_choose {
                    border: 2px solid #C1694E;
                    border-radius: 50%;
                    padding: 1px 1px;
                    box-sizing: border-box;

                }

                .scenicsRecorder_ch {
                    border: 2px solid #fff;
                    border-radius: 50%;
                    padding: 1px 1px;
                    box-sizing: border-box;
                }

                .scenicsRecorder_name {
                    background-color: #C1694E;
                    color: #fff;
                }
            }

            .pack_box {
                margin-top: 16px;
            }

            .pack {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #767676;
            }

            .packup {
                width: 12px;
                height: 12px;
                margin-left: 4px;
            }

        }

    }
</style>


// WEBPACK FOOTER //
// src/components/pageLeafletIndex.vue